'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var http$1 = require('http');
var https = require('https');
var url = require('url');
var require$$0 = require('stream');
var assert = require('assert');
var tty = require('tty');
var util = require('util');
var os = require('os');
var zlib = require('zlib');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var http__default = /*#__PURE__*/_interopDefaultLegacy(http$1);
var https__default = /*#__PURE__*/_interopDefaultLegacy(https);
var url__default = /*#__PURE__*/_interopDefaultLegacy(url);
var require$$0__default = /*#__PURE__*/_interopDefaultLegacy(require$$0);
var assert__default = /*#__PURE__*/_interopDefaultLegacy(assert);
var tty__default = /*#__PURE__*/_interopDefaultLegacy(tty);
var util__default = /*#__PURE__*/_interopDefaultLegacy(util);
var os__default = /*#__PURE__*/_interopDefaultLegacy(os);
var zlib__default = /*#__PURE__*/_interopDefaultLegacy(zlib);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

var strictUriEncode = str => encodeURIComponent(str).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);

var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp('(' + token + ')|([^%]+?)', 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return [decodeURIComponent(components.join(''))];
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher) || [];

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher) || [];
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

var decodeUriComponent = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};

var splitOnFirst = (string, separator) => {
	if (!(typeof string === 'string' && typeof separator === 'string')) {
		throw new TypeError('Expected the arguments to be of type `string`');
	}

	if (separator === '') {
		return [string];
	}

	const separatorIndex = string.indexOf(separator);

	if (separatorIndex === -1) {
		return [string];
	}

	return [
		string.slice(0, separatorIndex),
		string.slice(separatorIndex + separator.length)
	];
};

var filterObj = function (obj, predicate) {
	var ret = {};
	var keys = Object.keys(obj);
	var isArr = Array.isArray(predicate);

	for (var i = 0; i < keys.length; i++) {
		var key = keys[i];
		var val = obj[key];

		if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) {
			ret[key] = val;
		}
	}

	return ret;
};

var queryString = createCommonjsModule(function (module, exports) {





const isNullOrUndefined = value => value === null || value === undefined;

function encoderForArrayFormat(options) {
	switch (options.arrayFormat) {
		case 'index':
			return key => (result, value) => {
				const index = result.length;

				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), '[', index, ']'].join('')];
				}

				return [
					...result,
					[encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join('')
				];
			};

		case 'bracket':
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), '[]'].join('')];
				}

				return [...result, [encode(key, options), '[]=', encode(value, options)].join('')];
			};

		case 'comma':
		case 'separator':
			return key => (result, value) => {
				if (value === null || value === undefined || value.length === 0) {
					return result;
				}

				if (result.length === 0) {
					return [[encode(key, options), '=', encode(value, options)].join('')];
				}

				return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
			};

		default:
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, encode(key, options)];
				}

				return [...result, [encode(key, options), '=', encode(value, options)].join('')];
			};
	}
}

function parserForArrayFormat(options) {
	let result;

	switch (options.arrayFormat) {
		case 'index':
			return (key, value, accumulator) => {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return (key, value, accumulator) => {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		case 'comma':
		case 'separator':
			return (key, value, accumulator) => {
				const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
				const isEncodedArray = (typeof value === 'string' && !isArray && decode(value, options).includes(options.arrayFormatSeparator));
				value = isEncodedArray ? decode(value, options) : value;
				const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(item => decode(item, options)) : value === null ? value : decode(value, options);
				accumulator[key] = newValue;
			};

		default:
			return (key, value, accumulator) => {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function validateArrayFormatSeparator(value) {
	if (typeof value !== 'string' || value.length !== 1) {
		throw new TypeError('arrayFormatSeparator must be single character string');
	}
}

function encode(value, options) {
	if (options.encode) {
		return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function decode(value, options) {
	if (options.decode) {
		return decodeUriComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	}

	if (typeof input === 'object') {
		return keysSorter(Object.keys(input))
			.sort((a, b) => Number(a) - Number(b))
			.map(key => input[key]);
	}

	return input;
}

function removeHash(input) {
	const hashStart = input.indexOf('#');
	if (hashStart !== -1) {
		input = input.slice(0, hashStart);
	}

	return input;
}

function getHash(url) {
	let hash = '';
	const hashStart = url.indexOf('#');
	if (hashStart !== -1) {
		hash = url.slice(hashStart);
	}

	return hash;
}

function extract(input) {
	input = removeHash(input);
	const queryStart = input.indexOf('?');
	if (queryStart === -1) {
		return '';
	}

	return input.slice(queryStart + 1);
}

function parseValue(value, options) {
	if (options.parseNumbers && !Number.isNaN(Number(value)) && (typeof value === 'string' && value.trim() !== '')) {
		value = Number(value);
	} else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
		value = value.toLowerCase() === 'true';
	}

	return value;
}

function parse(query, options) {
	options = Object.assign({
		decode: true,
		sort: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ',',
		parseNumbers: false,
		parseBooleans: false
	}, options);

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const formatter = parserForArrayFormat(options);

	// Create an object with no prototype
	const ret = Object.create(null);

	if (typeof query !== 'string') {
		return ret;
	}

	query = query.trim().replace(/^[?#&]/, '');

	if (!query) {
		return ret;
	}

	for (const param of query.split('&')) {
		if (param === '') {
			continue;
		}

		let [key, value] = splitOnFirst(options.decode ? param.replace(/\+/g, ' ') : param, '=');

		// Missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		value = value === undefined ? null : ['comma', 'separator'].includes(options.arrayFormat) ? value : decode(value, options);
		formatter(decode(key, options), value, ret);
	}

	for (const key of Object.keys(ret)) {
		const value = ret[key];
		if (typeof value === 'object' && value !== null) {
			for (const k of Object.keys(value)) {
				value[k] = parseValue(value[k], options);
			}
		} else {
			ret[key] = parseValue(value, options);
		}
	}

	if (options.sort === false) {
		return ret;
	}

	return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key) => {
		const value = ret[key];
		if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) {
			// Sort object keys, not values
			result[key] = keysSorter(value);
		} else {
			result[key] = value;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = (object, options) => {
	if (!object) {
		return '';
	}

	options = Object.assign({
		encode: true,
		strict: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ','
	}, options);

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const shouldFilter = key => (
		(options.skipNull && isNullOrUndefined(object[key])) ||
		(options.skipEmptyString && object[key] === '')
	);

	const formatter = encoderForArrayFormat(options);

	const objectCopy = {};

	for (const key of Object.keys(object)) {
		if (!shouldFilter(key)) {
			objectCopy[key] = object[key];
		}
	}

	const keys = Object.keys(objectCopy);

	if (options.sort !== false) {
		keys.sort(options.sort);
	}

	return keys.map(key => {
		const value = object[key];

		if (value === undefined) {
			return '';
		}

		if (value === null) {
			return encode(key, options);
		}

		if (Array.isArray(value)) {
			return value
				.reduce(formatter(key), [])
				.join('&');
		}

		return encode(key, options) + '=' + encode(value, options);
	}).filter(x => x.length > 0).join('&');
};

exports.parseUrl = (url, options) => {
	options = Object.assign({
		decode: true
	}, options);

	const [url_, hash] = splitOnFirst(url, '#');

	return Object.assign(
		{
			url: url_.split('?')[0] || '',
			query: parse(extract(url), options)
		},
		options && options.parseFragmentIdentifier && hash ? {fragmentIdentifier: decode(hash, options)} : {}
	);
};

exports.stringifyUrl = (object, options) => {
	options = Object.assign({
		encode: true,
		strict: true
	}, options);

	const url = removeHash(object.url).split('?')[0] || '';
	const queryFromUrl = exports.extract(object.url);
	const parsedQueryFromUrl = exports.parse(queryFromUrl, {sort: false});

	const query = Object.assign(parsedQueryFromUrl, object.query);
	let queryString = exports.stringify(query, options);
	if (queryString) {
		queryString = `?${queryString}`;
	}

	let hash = getHash(object.url);
	if (object.fragmentIdentifier) {
		hash = `#${encode(object.fragmentIdentifier, options)}`;
	}

	return `${url}${queryString}${hash}`;
};

exports.pick = (input, filter, options) => {
	options = Object.assign({
		parseFragmentIdentifier: true
	}, options);

	const {url, query, fragmentIdentifier} = exports.parseUrl(input, options);
	return exports.stringifyUrl({
		url,
		query: filterObj(query, filter),
		fragmentIdentifier
	}, options);
};

exports.exclude = (input, filter, options) => {
	const exclusionFilter = Array.isArray(filter) ? key => !filter.includes(key) : (key, value) => !filter(key, value);

	return exports.pick(input, exclusionFilter, options);
};
});

var ONE_SECOND = 1000;
var secondsToMs = function (seconds) { return seconds * ONE_SECOND; };
var minutesToMs = function (minutes) { return secondsToMs(60 * minutes); };

var authStorageKey = 'auth';
var trustedDeviceStorageKey = 'trustedDeviceId';
var stagingHades = 'https://staging-hades-backend.dental21.de';
var productionHades = 'https://hades-backend.dental21.de';
var refreshTokenHeader = 'x-refresh-token';
var isTrustedDeviceHeader = 'X-Auth-Requires-2FA';
var credentialEvent = 'credentials-changed';
var redirectCookieKey = 'redirectLocation';
var missingConsentsHeader = 'missing-consents';
// This value is used to schedule the token refresh.
var refreshTokenThreshold = minutesToMs(5);

var isBrowser = typeof window !== 'undefined';
var getItem = function (key) {
    var valueFromSessionStorage = sessionStorage.getItem(key);
    if (valueFromSessionStorage) {
        try {
            var credentials = JSON.parse(valueFromSessionStorage);
            if (credentials.token)
                return valueFromSessionStorage;
        }
        catch (e) { }
    }
    return localStorage.getItem(key);
};
var setItem = function (key, value, storageType) {
    var isInvalid = !value || value === 'null';
    // We are using sessionStorage to storage the JWT when it comes from the URL (it usually happens when
    // the user is impersonated by another person), in this case, the credentials must be removed when the
    // tab is closed and it's only possible when using sessionStorage.
    var storage = storageType === 'local' ? localStorage : sessionStorage;
    if (isInvalid)
        return storage.removeItem(key);
    return storage.setItem(key, value);
};
var nextValue = function (value) {
    try {
        return JSON.parse(value);
    }
    catch (e) {
        return false;
    }
};
/* Persist a value in the localStorage or sessionStorage
 *
 * @param any defaultValue - The initial value
 * @param string key - The storage key key
 * @param string storageType - The storage type (localStorage or sessionStorage)
 */
var useStickyState = function (defaultValue, key) {
    var _a = React.useState(function () {
        var stickyValue = isBrowser ? getItem(key) : null;
        return nextValue(stickyValue) || stickyValue || defaultValue;
    }), value = _a[0], setValue = _a[1];
    var handleSetValue = React.useCallback(function (value, storageType) {
        setValue(function (pv) {
            var isObjectEntry = typeof pv === 'object' && typeof value === 'object';
            setItem(key, isObjectEntry && value ? JSON.stringify(__assign(__assign({}, pv), value)) : JSON.stringify(value), storageType);
            return isObjectEntry && value ? __assign(__assign({}, pv), value) : value;
        });
    }, [setItem, key]);
    return [value, handleSetValue];
};

var initSecurity = {
    token: null,
    refreshToken: null,
    authentication: null,
    missingConsents: null,
};
var CredentialsContext = React.createContext(initSecurity);
var CredentialsContextChange = React.createContext(function () { });
var CredentialsProvider = function (_a) {
    var children = _a.children;
    var _b = useStickyState(initSecurity, authStorageKey), credentials = _b[0], setCredentials = _b[1];
    return (React__default["default"].createElement(CredentialsContext.Provider, { value: credentials },
        React__default["default"].createElement(CredentialsContextChange.Provider, { value: setCredentials }, children)));
};
var useCredentials = function () {
    var context = React.useContext(CredentialsContext);
    if (context === undefined) {
        throw new Error('useCredentials must be used within the CredentialsProvider.');
    }
    return context || initSecurity;
};
var useSetCredentials = function () {
    var context = React.useContext(CredentialsContextChange);
    if (!context) {
        throw new Error('useSetCredentials must be used within the CredentialsProvider.');
    }
    return context;
};

var bind = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return Array.isArray(val);
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer$1(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return toString.call(val) === '[object FormData]';
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString$1(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction$1(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction$1(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return toString.call(val) === '[object URLSearchParams]';
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

var utils = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer$1,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString$1,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction$1,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
var buildURL = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

var InterceptorManager_1 = InterceptorManager;

var normalizeHeaderName = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
var enhanceError = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  };
  return error;
};

var transitional = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
var createError = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
var settle = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};

var cookies = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
var isAbsoluteURL = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
var combineURLs = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
var buildFullPath = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
var parseHeaders = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

var isURLSameOrigin = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);

/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

var Cancel_1 = Cancel;

var xhr = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional$1 = config.transitional || transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        transitional$1.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new Cancel_1('canceled') : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

/**
 * Helpers.
 */
var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var w = d * 7;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

var ms = function (val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isFinite(val)) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'weeks':
    case 'week':
    case 'w':
      return n * w;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (msAbs >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (msAbs >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (msAbs >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return plural(ms, msAbs, d, 'day');
  }
  if (msAbs >= h) {
    return plural(ms, msAbs, h, 'hour');
  }
  if (msAbs >= m) {
    return plural(ms, msAbs, m, 'minute');
  }
  if (msAbs >= s) {
    return plural(ms, msAbs, s, 'second');
  }
  return ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, msAbs, n, name) {
  var isPlural = msAbs >= n * 1.5;
  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}

/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */

function setup(env) {
	createDebug.debug = createDebug;
	createDebug.default = createDebug;
	createDebug.coerce = coerce;
	createDebug.disable = disable;
	createDebug.enable = enable;
	createDebug.enabled = enabled;
	createDebug.humanize = ms;
	createDebug.destroy = destroy;

	Object.keys(env).forEach(key => {
		createDebug[key] = env[key];
	});

	/**
	* The currently active debug mode names, and names to skip.
	*/

	createDebug.names = [];
	createDebug.skips = [];

	/**
	* Map of special "%n" handling functions, for the debug "format" argument.
	*
	* Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	*/
	createDebug.formatters = {};

	/**
	* Selects a color for a debug namespace
	* @param {String} namespace The namespace string for the debug instance to be colored
	* @return {Number|String} An ANSI color code for the given namespace
	* @api private
	*/
	function selectColor(namespace) {
		let hash = 0;

		for (let i = 0; i < namespace.length; i++) {
			hash = ((hash << 5) - hash) + namespace.charCodeAt(i);
			hash |= 0; // Convert to 32bit integer
		}

		return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
	}
	createDebug.selectColor = selectColor;

	/**
	* Create a debugger with the given `namespace`.
	*
	* @param {String} namespace
	* @return {Function}
	* @api public
	*/
	function createDebug(namespace) {
		let prevTime;
		let enableOverride = null;
		let namespacesCache;
		let enabledCache;

		function debug(...args) {
			// Disabled?
			if (!debug.enabled) {
				return;
			}

			const self = debug;

			// Set `diff` timestamp
			const curr = Number(new Date());
			const ms = curr - (prevTime || curr);
			self.diff = ms;
			self.prev = prevTime;
			self.curr = curr;
			prevTime = curr;

			args[0] = createDebug.coerce(args[0]);

			if (typeof args[0] !== 'string') {
				// Anything else let's inspect with %O
				args.unshift('%O');
			}

			// Apply any `formatters` transformations
			let index = 0;
			args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format) => {
				// If we encounter an escaped % then don't increase the array index
				if (match === '%%') {
					return '%';
				}
				index++;
				const formatter = createDebug.formatters[format];
				if (typeof formatter === 'function') {
					const val = args[index];
					match = formatter.call(self, val);

					// Now we need to remove `args[index]` since it's inlined in the `format`
					args.splice(index, 1);
					index--;
				}
				return match;
			});

			// Apply env-specific formatting (colors, etc.)
			createDebug.formatArgs.call(self, args);

			const logFn = self.log || createDebug.log;
			logFn.apply(self, args);
		}

		debug.namespace = namespace;
		debug.useColors = createDebug.useColors();
		debug.color = createDebug.selectColor(namespace);
		debug.extend = extend;
		debug.destroy = createDebug.destroy; // XXX Temporary. Will be removed in the next major release.

		Object.defineProperty(debug, 'enabled', {
			enumerable: true,
			configurable: false,
			get: () => {
				if (enableOverride !== null) {
					return enableOverride;
				}
				if (namespacesCache !== createDebug.namespaces) {
					namespacesCache = createDebug.namespaces;
					enabledCache = createDebug.enabled(namespace);
				}

				return enabledCache;
			},
			set: v => {
				enableOverride = v;
			}
		});

		// Env-specific initialization logic for debug instances
		if (typeof createDebug.init === 'function') {
			createDebug.init(debug);
		}

		return debug;
	}

	function extend(namespace, delimiter) {
		const newDebug = createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
		newDebug.log = this.log;
		return newDebug;
	}

	/**
	* Enables a debug mode by namespaces. This can include modes
	* separated by a colon and wildcards.
	*
	* @param {String} namespaces
	* @api public
	*/
	function enable(namespaces) {
		createDebug.save(namespaces);
		createDebug.namespaces = namespaces;

		createDebug.names = [];
		createDebug.skips = [];

		const split = (typeof namespaces === 'string' ? namespaces : '')
			.trim()
			.replace(' ', ',')
			.split(',')
			.filter(Boolean);

		for (const ns of split) {
			if (ns[0] === '-') {
				createDebug.skips.push(ns.slice(1));
			} else {
				createDebug.names.push(ns);
			}
		}
	}

	/**
	 * Checks if the given string matches a namespace template, honoring
	 * asterisks as wildcards.
	 *
	 * @param {String} search
	 * @param {String} template
	 * @return {Boolean}
	 */
	function matchesTemplate(search, template) {
		let searchIndex = 0;
		let templateIndex = 0;
		let starIndex = -1;
		let matchIndex = 0;

		while (searchIndex < search.length) {
			if (templateIndex < template.length && (template[templateIndex] === search[searchIndex] || template[templateIndex] === '*')) {
				// Match character or proceed with wildcard
				if (template[templateIndex] === '*') {
					starIndex = templateIndex;
					matchIndex = searchIndex;
					templateIndex++; // Skip the '*'
				} else {
					searchIndex++;
					templateIndex++;
				}
			} else if (starIndex !== -1) { // eslint-disable-line no-negated-condition
				// Backtrack to the last '*' and try to match more characters
				templateIndex = starIndex + 1;
				matchIndex++;
				searchIndex = matchIndex;
			} else {
				return false; // No match
			}
		}

		// Handle trailing '*' in template
		while (templateIndex < template.length && template[templateIndex] === '*') {
			templateIndex++;
		}

		return templateIndex === template.length;
	}

	/**
	* Disable debug output.
	*
	* @return {String} namespaces
	* @api public
	*/
	function disable() {
		const namespaces = [
			...createDebug.names,
			...createDebug.skips.map(namespace => '-' + namespace)
		].join(',');
		createDebug.enable('');
		return namespaces;
	}

	/**
	* Returns true if the given mode name is enabled, false otherwise.
	*
	* @param {String} name
	* @return {Boolean}
	* @api public
	*/
	function enabled(name) {
		for (const skip of createDebug.skips) {
			if (matchesTemplate(name, skip)) {
				return false;
			}
		}

		for (const ns of createDebug.names) {
			if (matchesTemplate(name, ns)) {
				return true;
			}
		}

		return false;
	}

	/**
	* Coerce `val`.
	*
	* @param {Mixed} val
	* @return {Mixed}
	* @api private
	*/
	function coerce(val) {
		if (val instanceof Error) {
			return val.stack || val.message;
		}
		return val;
	}

	/**
	* XXX DO NOT USE. This is a temporary stub function.
	* XXX It WILL be removed in the next major release.
	*/
	function destroy() {
		console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
	}

	createDebug.enable(createDebug.load());

	return createDebug;
}

var common = setup;

/* eslint-env browser */

var browser = createCommonjsModule(function (module, exports) {
/**
 * This is the web browser implementation of `debug()`.
 */

exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();
exports.destroy = (() => {
	let warned = false;

	return () => {
		if (!warned) {
			warned = true;
			console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
		}
	};
})();

/**
 * Colors.
 */

exports.colors = [
	'#0000CC',
	'#0000FF',
	'#0033CC',
	'#0033FF',
	'#0066CC',
	'#0066FF',
	'#0099CC',
	'#0099FF',
	'#00CC00',
	'#00CC33',
	'#00CC66',
	'#00CC99',
	'#00CCCC',
	'#00CCFF',
	'#3300CC',
	'#3300FF',
	'#3333CC',
	'#3333FF',
	'#3366CC',
	'#3366FF',
	'#3399CC',
	'#3399FF',
	'#33CC00',
	'#33CC33',
	'#33CC66',
	'#33CC99',
	'#33CCCC',
	'#33CCFF',
	'#6600CC',
	'#6600FF',
	'#6633CC',
	'#6633FF',
	'#66CC00',
	'#66CC33',
	'#9900CC',
	'#9900FF',
	'#9933CC',
	'#9933FF',
	'#99CC00',
	'#99CC33',
	'#CC0000',
	'#CC0033',
	'#CC0066',
	'#CC0099',
	'#CC00CC',
	'#CC00FF',
	'#CC3300',
	'#CC3333',
	'#CC3366',
	'#CC3399',
	'#CC33CC',
	'#CC33FF',
	'#CC6600',
	'#CC6633',
	'#CC9900',
	'#CC9933',
	'#CCCC00',
	'#CCCC33',
	'#FF0000',
	'#FF0033',
	'#FF0066',
	'#FF0099',
	'#FF00CC',
	'#FF00FF',
	'#FF3300',
	'#FF3333',
	'#FF3366',
	'#FF3399',
	'#FF33CC',
	'#FF33FF',
	'#FF6600',
	'#FF6633',
	'#FF9900',
	'#FF9933',
	'#FFCC00',
	'#FFCC33'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

// eslint-disable-next-line complexity
function useColors() {
	// NB: In an Electron preload script, document will be defined but not fully
	// initialized. Since we know we're in Chrome, we'll just detect this case
	// explicitly
	if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) {
		return true;
	}

	// Internet Explorer and Edge do not support colors.
	if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
		return false;
	}

	let m;

	// Is webkit? http://stackoverflow.com/a/16459606/376773
	// document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	// eslint-disable-next-line no-return-assign
	return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
		// Is firebug? http://stackoverflow.com/a/398120/376773
		(typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
		// Is firefox >= v31?
		// https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
		(typeof navigator !== 'undefined' && navigator.userAgent && (m = navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)) && parseInt(m[1], 10) >= 31) ||
		// Double check webkit in userAgent just in case we are in a worker
		(typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
	args[0] = (this.useColors ? '%c' : '') +
		this.namespace +
		(this.useColors ? ' %c' : ' ') +
		args[0] +
		(this.useColors ? '%c ' : ' ') +
		'+' + module.exports.humanize(this.diff);

	if (!this.useColors) {
		return;
	}

	const c = 'color: ' + this.color;
	args.splice(1, 0, c, 'color: inherit');

	// The final "%c" is somewhat tricky, because there could be other
	// arguments passed either before or after the %c, so we need to
	// figure out the correct index to insert the CSS into
	let index = 0;
	let lastC = 0;
	args[0].replace(/%[a-zA-Z%]/g, match => {
		if (match === '%%') {
			return;
		}
		index++;
		if (match === '%c') {
			// We only are interested in the *last* %c
			// (the user may have provided their own)
			lastC = index;
		}
	});

	args.splice(lastC, 0, c);
}

/**
 * Invokes `console.debug()` when available.
 * No-op when `console.debug` is not a "function".
 * If `console.debug` is not available, falls back
 * to `console.log`.
 *
 * @api public
 */
exports.log = console.debug || console.log || (() => {});

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */
function save(namespaces) {
	try {
		if (namespaces) {
			exports.storage.setItem('debug', namespaces);
		} else {
			exports.storage.removeItem('debug');
		}
	} catch (error) {
		// Swallow
		// XXX (@Qix-) should we be logging these?
	}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */
function load() {
	let r;
	try {
		r = exports.storage.getItem('debug');
	} catch (error) {
		// Swallow
		// XXX (@Qix-) should we be logging these?
	}

	// If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	if (!r && typeof process !== 'undefined' && 'env' in process) {
		r = process.env.DEBUG;
	}

	return r;
}

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
	try {
		// TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
		// The Browser also has localStorage in the global context.
		return localStorage;
	} catch (error) {
		// Swallow
		// XXX (@Qix-) should we be logging these?
	}
}

module.exports = common(exports);

const {formatters} = module.exports;

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

formatters.j = function (v) {
	try {
		return JSON.stringify(v);
	} catch (error) {
		return '[UnexpectedJSONParseError]: ' + error.message;
	}
};
});

var hasFlag = (flag, argv) => {
	argv = argv || process.argv;
	const prefix = flag.startsWith('-') ? '' : (flag.length === 1 ? '-' : '--');
	const pos = argv.indexOf(prefix + flag);
	const terminatorPos = argv.indexOf('--');
	return pos !== -1 && (terminatorPos === -1 ? true : pos < terminatorPos);
};

const env = process.env;

let forceColor;
if (hasFlag('no-color') ||
	hasFlag('no-colors') ||
	hasFlag('color=false')) {
	forceColor = false;
} else if (hasFlag('color') ||
	hasFlag('colors') ||
	hasFlag('color=true') ||
	hasFlag('color=always')) {
	forceColor = true;
}
if ('FORCE_COLOR' in env) {
	forceColor = env.FORCE_COLOR.length === 0 || parseInt(env.FORCE_COLOR, 10) !== 0;
}

function translateLevel(level) {
	if (level === 0) {
		return false;
	}

	return {
		level,
		hasBasic: true,
		has256: level >= 2,
		has16m: level >= 3
	};
}

function supportsColor(stream) {
	if (forceColor === false) {
		return 0;
	}

	if (hasFlag('color=16m') ||
		hasFlag('color=full') ||
		hasFlag('color=truecolor')) {
		return 3;
	}

	if (hasFlag('color=256')) {
		return 2;
	}

	if (stream && !stream.isTTY && forceColor !== true) {
		return 0;
	}

	const min = forceColor ? 1 : 0;

	if (process.platform === 'win32') {
		// Node.js 7.5.0 is the first version of Node.js to include a patch to
		// libuv that enables 256 color output on Windows. Anything earlier and it
		// won't work. However, here we target Node.js 8 at minimum as it is an LTS
		// release, and Node.js 7 is not. Windows 10 build 10586 is the first Windows
		// release that supports 256 colors. Windows 10 build 14931 is the first release
		// that supports 16m/TrueColor.
		const osRelease = os__default["default"].release().split('.');
		if (
			Number(process.versions.node.split('.')[0]) >= 8 &&
			Number(osRelease[0]) >= 10 &&
			Number(osRelease[2]) >= 10586
		) {
			return Number(osRelease[2]) >= 14931 ? 3 : 2;
		}

		return 1;
	}

	if ('CI' in env) {
		if (['TRAVIS', 'CIRCLECI', 'APPVEYOR', 'GITLAB_CI'].some(sign => sign in env) || env.CI_NAME === 'codeship') {
			return 1;
		}

		return min;
	}

	if ('TEAMCITY_VERSION' in env) {
		return /^(9\.(0*[1-9]\d*)\.|\d{2,}\.)/.test(env.TEAMCITY_VERSION) ? 1 : 0;
	}

	if (env.COLORTERM === 'truecolor') {
		return 3;
	}

	if ('TERM_PROGRAM' in env) {
		const version = parseInt((env.TERM_PROGRAM_VERSION || '').split('.')[0], 10);

		switch (env.TERM_PROGRAM) {
			case 'iTerm.app':
				return version >= 3 ? 3 : 2;
			case 'Apple_Terminal':
				return 2;
			// No default
		}
	}

	if (/-256(color)?$/i.test(env.TERM)) {
		return 2;
	}

	if (/^screen|^xterm|^vt100|^vt220|^rxvt|color|ansi|cygwin|linux/i.test(env.TERM)) {
		return 1;
	}

	if ('COLORTERM' in env) {
		return 1;
	}

	if (env.TERM === 'dumb') {
		return min;
	}

	return min;
}

function getSupportLevel(stream) {
	const level = supportsColor(stream);
	return translateLevel(level);
}

var supportsColor_1 = {
	supportsColor: getSupportLevel,
	stdout: getSupportLevel(process.stdout),
	stderr: getSupportLevel(process.stderr)
};

/**
 * Module dependencies.
 */

var node = createCommonjsModule(function (module, exports) {
/**
 * This is the Node.js implementation of `debug()`.
 */

exports.init = init;
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.destroy = util__default["default"].deprecate(
	() => {},
	'Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.'
);

/**
 * Colors.
 */

exports.colors = [6, 2, 3, 4, 5, 1];

try {
	// Optional dependency (as in, doesn't need to be installed, NOT like optionalDependencies in package.json)
	// eslint-disable-next-line import/no-extraneous-dependencies
	const supportsColor = supportsColor_1;

	if (supportsColor && (supportsColor.stderr || supportsColor).level >= 2) {
		exports.colors = [
			20,
			21,
			26,
			27,
			32,
			33,
			38,
			39,
			40,
			41,
			42,
			43,
			44,
			45,
			56,
			57,
			62,
			63,
			68,
			69,
			74,
			75,
			76,
			77,
			78,
			79,
			80,
			81,
			92,
			93,
			98,
			99,
			112,
			113,
			128,
			129,
			134,
			135,
			148,
			149,
			160,
			161,
			162,
			163,
			164,
			165,
			166,
			167,
			168,
			169,
			170,
			171,
			172,
			173,
			178,
			179,
			184,
			185,
			196,
			197,
			198,
			199,
			200,
			201,
			202,
			203,
			204,
			205,
			206,
			207,
			208,
			209,
			214,
			215,
			220,
			221
		];
	}
} catch (error) {
	// Swallow - we only care if `supports-color` is available; it doesn't have to be.
}

/**
 * Build up the default `inspectOpts` object from the environment variables.
 *
 *   $ DEBUG_COLORS=no DEBUG_DEPTH=10 DEBUG_SHOW_HIDDEN=enabled node script.js
 */

exports.inspectOpts = Object.keys(process.env).filter(key => {
	return /^debug_/i.test(key);
}).reduce((obj, key) => {
	// Camel-case
	const prop = key
		.substring(6)
		.toLowerCase()
		.replace(/_([a-z])/g, (_, k) => {
			return k.toUpperCase();
		});

	// Coerce string value into JS value
	let val = process.env[key];
	if (/^(yes|on|true|enabled)$/i.test(val)) {
		val = true;
	} else if (/^(no|off|false|disabled)$/i.test(val)) {
		val = false;
	} else if (val === 'null') {
		val = null;
	} else {
		val = Number(val);
	}

	obj[prop] = val;
	return obj;
}, {});

/**
 * Is stdout a TTY? Colored output is enabled when `true`.
 */

function useColors() {
	return 'colors' in exports.inspectOpts ?
		Boolean(exports.inspectOpts.colors) :
		tty__default["default"].isatty(process.stderr.fd);
}

/**
 * Adds ANSI color escape codes if enabled.
 *
 * @api public
 */

function formatArgs(args) {
	const {namespace: name, useColors} = this;

	if (useColors) {
		const c = this.color;
		const colorCode = '\u001B[3' + (c < 8 ? c : '8;5;' + c);
		const prefix = `  ${colorCode};1m${name} \u001B[0m`;

		args[0] = prefix + args[0].split('\n').join('\n' + prefix);
		args.push(colorCode + 'm+' + module.exports.humanize(this.diff) + '\u001B[0m');
	} else {
		args[0] = getDate() + name + ' ' + args[0];
	}
}

function getDate() {
	if (exports.inspectOpts.hideDate) {
		return '';
	}
	return new Date().toISOString() + ' ';
}

/**
 * Invokes `util.formatWithOptions()` with the specified arguments and writes to stderr.
 */

function log(...args) {
	return process.stderr.write(util__default["default"].formatWithOptions(exports.inspectOpts, ...args) + '\n');
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */
function save(namespaces) {
	if (namespaces) {
		process.env.DEBUG = namespaces;
	} else {
		// If you set a process.env field to null or undefined, it gets cast to the
		// string 'null' or 'undefined'. Just delete instead.
		delete process.env.DEBUG;
	}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
	return process.env.DEBUG;
}

/**
 * Init logic for `debug` instances.
 *
 * Create a new `inspectOpts` object in case `useColors` is set
 * differently for a particular `debug` instance.
 */

function init(debug) {
	debug.inspectOpts = {};

	const keys = Object.keys(exports.inspectOpts);
	for (let i = 0; i < keys.length; i++) {
		debug.inspectOpts[keys[i]] = exports.inspectOpts[keys[i]];
	}
}

module.exports = common(exports);

const {formatters} = module.exports;

/**
 * Map %o to `util.inspect()`, all on a single line.
 */

formatters.o = function (v) {
	this.inspectOpts.colors = this.useColors;
	return util__default["default"].inspect(v, this.inspectOpts)
		.split('\n')
		.map(str => str.trim())
		.join(' ');
};

/**
 * Map %O to `util.inspect()`, allowing multiple lines if needed.
 */

formatters.O = function (v) {
	this.inspectOpts.colors = this.useColors;
	return util__default["default"].inspect(v, this.inspectOpts);
};
});

/**
 * Detect Electron renderer / nwjs process, which is node, but we should
 * treat as a browser.
 */

var src = createCommonjsModule(function (module) {
if (typeof process === 'undefined' || process.type === 'renderer' || process.browser === true || process.__nwjs) {
	module.exports = browser;
} else {
	module.exports = node;
}
});

var debug;

var debug_1 = function () {
  if (!debug) {
    try {
      /* eslint global-require: off */
      debug = src("follow-redirects");
    }
    catch (error) { /* */ }
    if (typeof debug !== "function") {
      debug = function () { /* */ };
    }
  }
  debug.apply(null, arguments);
};

var URL = url__default["default"].URL;


var Writable = require$$0__default["default"].Writable;



// Preventive platform detection
// istanbul ignore next
(function detectUnsupportedEnvironment() {
  var looksLikeNode = typeof process !== "undefined";
  var looksLikeBrowser = typeof window !== "undefined" && typeof document !== "undefined";
  var looksLikeV8 = isFunction(Error.captureStackTrace);
  if (!looksLikeNode && (looksLikeBrowser || !looksLikeV8)) {
    console.warn("The follow-redirects package should be excluded from browser builds.");
  }
}());

// Whether to use the native URL object or the legacy url module
var useNativeURL = false;
try {
  assert__default["default"](new URL(""));
}
catch (error) {
  useNativeURL = error.code === "ERR_INVALID_URL";
}

// URL fields to preserve in copy operations
var preservedUrlFields = [
  "auth",
  "host",
  "hostname",
  "href",
  "path",
  "pathname",
  "port",
  "protocol",
  "query",
  "search",
  "hash",
];

// Create handlers that pass events from native requests
var events = ["abort", "aborted", "connect", "error", "socket", "timeout"];
var eventHandlers = Object.create(null);
events.forEach(function (event) {
  eventHandlers[event] = function (arg1, arg2, arg3) {
    this._redirectable.emit(event, arg1, arg2, arg3);
  };
});

// Error types with codes
var InvalidUrlError = createErrorType(
  "ERR_INVALID_URL",
  "Invalid URL",
  TypeError
);
var RedirectionError = createErrorType(
  "ERR_FR_REDIRECTION_FAILURE",
  "Redirected request failed"
);
var TooManyRedirectsError = createErrorType(
  "ERR_FR_TOO_MANY_REDIRECTS",
  "Maximum number of redirects exceeded",
  RedirectionError
);
var MaxBodyLengthExceededError = createErrorType(
  "ERR_FR_MAX_BODY_LENGTH_EXCEEDED",
  "Request body larger than maxBodyLength limit"
);
var WriteAfterEndError = createErrorType(
  "ERR_STREAM_WRITE_AFTER_END",
  "write after end"
);

// istanbul ignore next
var destroy = Writable.prototype.destroy || noop$1;

// An HTTP(S) request that can be redirected
function RedirectableRequest(options, responseCallback) {
  // Initialize the request
  Writable.call(this);
  this._sanitizeOptions(options);
  this._options = options;
  this._ended = false;
  this._ending = false;
  this._redirectCount = 0;
  this._redirects = [];
  this._requestBodyLength = 0;
  this._requestBodyBuffers = [];

  // Attach a callback if passed
  if (responseCallback) {
    this.on("response", responseCallback);
  }

  // React to responses of native requests
  var self = this;
  this._onNativeResponse = function (response) {
    try {
      self._processResponse(response);
    }
    catch (cause) {
      self.emit("error", cause instanceof RedirectionError ?
        cause : new RedirectionError({ cause: cause }));
    }
  };

  // Perform the first request
  this._performRequest();
}
RedirectableRequest.prototype = Object.create(Writable.prototype);

RedirectableRequest.prototype.abort = function () {
  destroyRequest(this._currentRequest);
  this._currentRequest.abort();
  this.emit("abort");
};

RedirectableRequest.prototype.destroy = function (error) {
  destroyRequest(this._currentRequest, error);
  destroy.call(this, error);
  return this;
};

// Writes buffered data to the current native request
RedirectableRequest.prototype.write = function (data, encoding, callback) {
  // Writing is not allowed if end has been called
  if (this._ending) {
    throw new WriteAfterEndError();
  }

  // Validate input and shift parameters if necessary
  if (!isString(data) && !isBuffer(data)) {
    throw new TypeError("data should be a string, Buffer or Uint8Array");
  }
  if (isFunction(encoding)) {
    callback = encoding;
    encoding = null;
  }

  // Ignore empty buffers, since writing them doesn't invoke the callback
  // https://github.com/nodejs/node/issues/22066
  if (data.length === 0) {
    if (callback) {
      callback();
    }
    return;
  }
  // Only write when we don't exceed the maximum body length
  if (this._requestBodyLength + data.length <= this._options.maxBodyLength) {
    this._requestBodyLength += data.length;
    this._requestBodyBuffers.push({ data: data, encoding: encoding });
    this._currentRequest.write(data, encoding, callback);
  }
  // Error when we exceed the maximum body length
  else {
    this.emit("error", new MaxBodyLengthExceededError());
    this.abort();
  }
};

// Ends the current native request
RedirectableRequest.prototype.end = function (data, encoding, callback) {
  // Shift parameters if necessary
  if (isFunction(data)) {
    callback = data;
    data = encoding = null;
  }
  else if (isFunction(encoding)) {
    callback = encoding;
    encoding = null;
  }

  // Write data if needed and end
  if (!data) {
    this._ended = this._ending = true;
    this._currentRequest.end(null, null, callback);
  }
  else {
    var self = this;
    var currentRequest = this._currentRequest;
    this.write(data, encoding, function () {
      self._ended = true;
      currentRequest.end(null, null, callback);
    });
    this._ending = true;
  }
};

// Sets a header value on the current native request
RedirectableRequest.prototype.setHeader = function (name, value) {
  this._options.headers[name] = value;
  this._currentRequest.setHeader(name, value);
};

// Clears a header value on the current native request
RedirectableRequest.prototype.removeHeader = function (name) {
  delete this._options.headers[name];
  this._currentRequest.removeHeader(name);
};

// Global timeout for all underlying requests
RedirectableRequest.prototype.setTimeout = function (msecs, callback) {
  var self = this;

  // Destroys the socket on timeout
  function destroyOnTimeout(socket) {
    socket.setTimeout(msecs);
    socket.removeListener("timeout", socket.destroy);
    socket.addListener("timeout", socket.destroy);
  }

  // Sets up a timer to trigger a timeout event
  function startTimer(socket) {
    if (self._timeout) {
      clearTimeout(self._timeout);
    }
    self._timeout = setTimeout(function () {
      self.emit("timeout");
      clearTimer();
    }, msecs);
    destroyOnTimeout(socket);
  }

  // Stops a timeout from triggering
  function clearTimer() {
    // Clear the timeout
    if (self._timeout) {
      clearTimeout(self._timeout);
      self._timeout = null;
    }

    // Clean up all attached listeners
    self.removeListener("abort", clearTimer);
    self.removeListener("error", clearTimer);
    self.removeListener("response", clearTimer);
    self.removeListener("close", clearTimer);
    if (callback) {
      self.removeListener("timeout", callback);
    }
    if (!self.socket) {
      self._currentRequest.removeListener("socket", startTimer);
    }
  }

  // Attach callback if passed
  if (callback) {
    this.on("timeout", callback);
  }

  // Start the timer if or when the socket is opened
  if (this.socket) {
    startTimer(this.socket);
  }
  else {
    this._currentRequest.once("socket", startTimer);
  }

  // Clean up on events
  this.on("socket", destroyOnTimeout);
  this.on("abort", clearTimer);
  this.on("error", clearTimer);
  this.on("response", clearTimer);
  this.on("close", clearTimer);

  return this;
};

// Proxy all other public ClientRequest methods
[
  "flushHeaders", "getHeader",
  "setNoDelay", "setSocketKeepAlive",
].forEach(function (method) {
  RedirectableRequest.prototype[method] = function (a, b) {
    return this._currentRequest[method](a, b);
  };
});

// Proxy all public ClientRequest properties
["aborted", "connection", "socket"].forEach(function (property) {
  Object.defineProperty(RedirectableRequest.prototype, property, {
    get: function () { return this._currentRequest[property]; },
  });
});

RedirectableRequest.prototype._sanitizeOptions = function (options) {
  // Ensure headers are always present
  if (!options.headers) {
    options.headers = {};
  }

  // Since http.request treats host as an alias of hostname,
  // but the url module interprets host as hostname plus port,
  // eliminate the host property to avoid confusion.
  if (options.host) {
    // Use hostname if set, because it has precedence
    if (!options.hostname) {
      options.hostname = options.host;
    }
    delete options.host;
  }

  // Complete the URL object when necessary
  if (!options.pathname && options.path) {
    var searchPos = options.path.indexOf("?");
    if (searchPos < 0) {
      options.pathname = options.path;
    }
    else {
      options.pathname = options.path.substring(0, searchPos);
      options.search = options.path.substring(searchPos);
    }
  }
};


// Executes the next native request (initial or redirect)
RedirectableRequest.prototype._performRequest = function () {
  // Load the native protocol
  var protocol = this._options.protocol;
  var nativeProtocol = this._options.nativeProtocols[protocol];
  if (!nativeProtocol) {
    throw new TypeError("Unsupported protocol " + protocol);
  }

  // If specified, use the agent corresponding to the protocol
  // (HTTP and HTTPS use different types of agents)
  if (this._options.agents) {
    var scheme = protocol.slice(0, -1);
    this._options.agent = this._options.agents[scheme];
  }

  // Create the native request and set up its event handlers
  var request = this._currentRequest =
        nativeProtocol.request(this._options, this._onNativeResponse);
  request._redirectable = this;
  for (var event of events) {
    request.on(event, eventHandlers[event]);
  }

  // RFC7230§5.3.1: When making a request directly to an origin server, […]
  // a client MUST send only the absolute path […] as the request-target.
  this._currentUrl = /^\//.test(this._options.path) ?
    url__default["default"].format(this._options) :
    // When making a request to a proxy, […]
    // a client MUST send the target URI in absolute-form […].
    this._options.path;

  // End a redirected request
  // (The first request must be ended explicitly with RedirectableRequest#end)
  if (this._isRedirect) {
    // Write the request entity and end
    var i = 0;
    var self = this;
    var buffers = this._requestBodyBuffers;
    (function writeNext(error) {
      // Only write if this request has not been redirected yet
      // istanbul ignore else
      if (request === self._currentRequest) {
        // Report any write errors
        // istanbul ignore if
        if (error) {
          self.emit("error", error);
        }
        // Write the next buffer if there are still left
        else if (i < buffers.length) {
          var buffer = buffers[i++];
          // istanbul ignore else
          if (!request.finished) {
            request.write(buffer.data, buffer.encoding, writeNext);
          }
        }
        // End the request if `end` has been called on us
        else if (self._ended) {
          request.end();
        }
      }
    }());
  }
};

// Processes a response from the current native request
RedirectableRequest.prototype._processResponse = function (response) {
  // Store the redirected response
  var statusCode = response.statusCode;
  if (this._options.trackRedirects) {
    this._redirects.push({
      url: this._currentUrl,
      headers: response.headers,
      statusCode: statusCode,
    });
  }

  // RFC7231§6.4: The 3xx (Redirection) class of status code indicates
  // that further action needs to be taken by the user agent in order to
  // fulfill the request. If a Location header field is provided,
  // the user agent MAY automatically redirect its request to the URI
  // referenced by the Location field value,
  // even if the specific status code is not understood.

  // If the response is not a redirect; return it as-is
  var location = response.headers.location;
  if (!location || this._options.followRedirects === false ||
      statusCode < 300 || statusCode >= 400) {
    response.responseUrl = this._currentUrl;
    response.redirects = this._redirects;
    this.emit("response", response);

    // Clean up
    this._requestBodyBuffers = [];
    return;
  }

  // The response is a redirect, so abort the current request
  destroyRequest(this._currentRequest);
  // Discard the remainder of the response to avoid waiting for data
  response.destroy();

  // RFC7231§6.4: A client SHOULD detect and intervene
  // in cyclical redirections (i.e., "infinite" redirection loops).
  if (++this._redirectCount > this._options.maxRedirects) {
    throw new TooManyRedirectsError();
  }

  // Store the request headers if applicable
  var requestHeaders;
  var beforeRedirect = this._options.beforeRedirect;
  if (beforeRedirect) {
    requestHeaders = Object.assign({
      // The Host header was set by nativeProtocol.request
      Host: response.req.getHeader("host"),
    }, this._options.headers);
  }

  // RFC7231§6.4: Automatic redirection needs to done with
  // care for methods not known to be safe, […]
  // RFC7231§6.4.2–3: For historical reasons, a user agent MAY change
  // the request method from POST to GET for the subsequent request.
  var method = this._options.method;
  if ((statusCode === 301 || statusCode === 302) && this._options.method === "POST" ||
      // RFC7231§6.4.4: The 303 (See Other) status code indicates that
      // the server is redirecting the user agent to a different resource […]
      // A user agent can perform a retrieval request targeting that URI
      // (a GET or HEAD request if using HTTP) […]
      (statusCode === 303) && !/^(?:GET|HEAD)$/.test(this._options.method)) {
    this._options.method = "GET";
    // Drop a possible entity and headers related to it
    this._requestBodyBuffers = [];
    removeMatchingHeaders(/^content-/i, this._options.headers);
  }

  // Drop the Host header, as the redirect might lead to a different host
  var currentHostHeader = removeMatchingHeaders(/^host$/i, this._options.headers);

  // If the redirect is relative, carry over the host of the last request
  var currentUrlParts = parseUrl(this._currentUrl);
  var currentHost = currentHostHeader || currentUrlParts.host;
  var currentUrl = /^\w+:/.test(location) ? this._currentUrl :
    url__default["default"].format(Object.assign(currentUrlParts, { host: currentHost }));

  // Create the redirected request
  var redirectUrl = resolveUrl(location, currentUrl);
  debug_1("redirecting to", redirectUrl.href);
  this._isRedirect = true;
  spreadUrlObject(redirectUrl, this._options);

  // Drop confidential headers when redirecting to a less secure protocol
  // or to a different domain that is not a superdomain
  if (redirectUrl.protocol !== currentUrlParts.protocol &&
     redirectUrl.protocol !== "https:" ||
     redirectUrl.host !== currentHost &&
     !isSubdomain(redirectUrl.host, currentHost)) {
    removeMatchingHeaders(/^(?:(?:proxy-)?authorization|cookie)$/i, this._options.headers);
  }

  // Evaluate the beforeRedirect callback
  if (isFunction(beforeRedirect)) {
    var responseDetails = {
      headers: response.headers,
      statusCode: statusCode,
    };
    var requestDetails = {
      url: currentUrl,
      method: method,
      headers: requestHeaders,
    };
    beforeRedirect(this._options, responseDetails, requestDetails);
    this._sanitizeOptions(this._options);
  }

  // Perform the redirected request
  this._performRequest();
};

// Wraps the key/value object of protocols with redirect functionality
function wrap(protocols) {
  // Default settings
  var exports = {
    maxRedirects: 21,
    maxBodyLength: 10 * 1024 * 1024,
  };

  // Wrap each protocol
  var nativeProtocols = {};
  Object.keys(protocols).forEach(function (scheme) {
    var protocol = scheme + ":";
    var nativeProtocol = nativeProtocols[protocol] = protocols[scheme];
    var wrappedProtocol = exports[scheme] = Object.create(nativeProtocol);

    // Executes a request, following redirects
    function request(input, options, callback) {
      // Parse parameters, ensuring that input is an object
      if (isURL(input)) {
        input = spreadUrlObject(input);
      }
      else if (isString(input)) {
        input = spreadUrlObject(parseUrl(input));
      }
      else {
        callback = options;
        options = validateUrl(input);
        input = { protocol: protocol };
      }
      if (isFunction(options)) {
        callback = options;
        options = null;
      }

      // Set defaults
      options = Object.assign({
        maxRedirects: exports.maxRedirects,
        maxBodyLength: exports.maxBodyLength,
      }, input, options);
      options.nativeProtocols = nativeProtocols;
      if (!isString(options.host) && !isString(options.hostname)) {
        options.hostname = "::1";
      }

      assert__default["default"].equal(options.protocol, protocol, "protocol mismatch");
      debug_1("options", options);
      return new RedirectableRequest(options, callback);
    }

    // Executes a GET request, following redirects
    function get(input, options, callback) {
      var wrappedRequest = wrappedProtocol.request(input, options, callback);
      wrappedRequest.end();
      return wrappedRequest;
    }

    // Expose the properties on the wrapped protocol
    Object.defineProperties(wrappedProtocol, {
      request: { value: request, configurable: true, enumerable: true, writable: true },
      get: { value: get, configurable: true, enumerable: true, writable: true },
    });
  });
  return exports;
}

function noop$1() { /* empty */ }

function parseUrl(input) {
  var parsed;
  // istanbul ignore else
  if (useNativeURL) {
    parsed = new URL(input);
  }
  else {
    // Ensure the URL is valid and absolute
    parsed = validateUrl(url__default["default"].parse(input));
    if (!isString(parsed.protocol)) {
      throw new InvalidUrlError({ input });
    }
  }
  return parsed;
}

function resolveUrl(relative, base) {
  // istanbul ignore next
  return useNativeURL ? new URL(relative, base) : parseUrl(url__default["default"].resolve(base, relative));
}

function validateUrl(input) {
  if (/^\[/.test(input.hostname) && !/^\[[:0-9a-f]+\]$/i.test(input.hostname)) {
    throw new InvalidUrlError({ input: input.href || input });
  }
  if (/^\[/.test(input.host) && !/^\[[:0-9a-f]+\](:\d+)?$/i.test(input.host)) {
    throw new InvalidUrlError({ input: input.href || input });
  }
  return input;
}

function spreadUrlObject(urlObject, target) {
  var spread = target || {};
  for (var key of preservedUrlFields) {
    spread[key] = urlObject[key];
  }

  // Fix IPv6 hostname
  if (spread.hostname.startsWith("[")) {
    spread.hostname = spread.hostname.slice(1, -1);
  }
  // Ensure port is a number
  if (spread.port !== "") {
    spread.port = Number(spread.port);
  }
  // Concatenate path
  spread.path = spread.search ? spread.pathname + spread.search : spread.pathname;

  return spread;
}

function removeMatchingHeaders(regex, headers) {
  var lastValue;
  for (var header in headers) {
    if (regex.test(header)) {
      lastValue = headers[header];
      delete headers[header];
    }
  }
  return (lastValue === null || typeof lastValue === "undefined") ?
    undefined : String(lastValue).trim();
}

function createErrorType(code, message, baseClass) {
  // Create constructor
  function CustomError(properties) {
    // istanbul ignore else
    if (isFunction(Error.captureStackTrace)) {
      Error.captureStackTrace(this, this.constructor);
    }
    Object.assign(this, properties || {});
    this.code = code;
    this.message = this.cause ? message + ": " + this.cause.message : message;
  }

  // Attach constructor and set default properties
  CustomError.prototype = new (baseClass || Error)();
  Object.defineProperties(CustomError.prototype, {
    constructor: {
      value: CustomError,
      enumerable: false,
    },
    name: {
      value: "Error [" + code + "]",
      enumerable: false,
    },
  });
  return CustomError;
}

function destroyRequest(request, error) {
  for (var event of events) {
    request.removeListener(event, eventHandlers[event]);
  }
  request.on("error", noop$1);
  request.destroy(error);
}

function isSubdomain(subdomain, domain) {
  assert__default["default"](isString(subdomain) && isString(domain));
  var dot = subdomain.length - domain.length - 1;
  return dot > 0 && subdomain[dot] === "." && subdomain.endsWith(domain);
}

function isString(value) {
  return typeof value === "string" || value instanceof String;
}

function isFunction(value) {
  return typeof value === "function";
}

function isBuffer(value) {
  return typeof value === "object" && ("length" in value);
}

function isURL(value) {
  return URL && value instanceof URL;
}

// Exports
var followRedirects = wrap({ http: http__default["default"], https: https__default["default"] });
var wrap_1 = wrap;
followRedirects.wrap = wrap_1;

var data = {
  "version": "0.26.1"
};

var httpFollow = followRedirects.http;
var httpsFollow = followRedirects.https;


var VERSION$1 = data.version;





var isHttps = /https:?/;

/**
 *
 * @param {http.ClientRequestArgs} options
 * @param {AxiosProxyConfig} proxy
 * @param {string} location
 */
function setProxy(options, proxy, location) {
  options.hostname = proxy.host;
  options.host = proxy.host;
  options.port = proxy.port;
  options.path = location;

  // Basic proxy authorization
  if (proxy.auth) {
    var base64 = Buffer.from(proxy.auth.username + ':' + proxy.auth.password, 'utf8').toString('base64');
    options.headers['Proxy-Authorization'] = 'Basic ' + base64;
  }

  // If a proxy is used, any redirects must also pass through the proxy
  options.beforeRedirect = function beforeRedirect(redirection) {
    redirection.headers.host = redirection.host;
    setProxy(redirection, proxy, redirection.href);
  };
}

/*eslint consistent-return:0*/
var http_1 = function httpAdapter(config) {
  return new Promise(function dispatchHttpRequest(resolvePromise, rejectPromise) {
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }
    var resolve = function resolve(value) {
      done();
      resolvePromise(value);
    };
    var rejected = false;
    var reject = function reject(value) {
      done();
      rejected = true;
      rejectPromise(value);
    };
    var data = config.data;
    var headers = config.headers;
    var headerNames = {};

    Object.keys(headers).forEach(function storeLowerName(name) {
      headerNames[name.toLowerCase()] = name;
    });

    // Set User-Agent (required by some servers)
    // See https://github.com/axios/axios/issues/69
    if ('user-agent' in headerNames) {
      // User-Agent is specified; handle case where no UA header is desired
      if (!headers[headerNames['user-agent']]) {
        delete headers[headerNames['user-agent']];
      }
      // Otherwise, use specified value
    } else {
      // Only set header if it hasn't been set in config
      headers['User-Agent'] = 'axios/' + VERSION$1;
    }

    if (data && !utils.isStream(data)) {
      if (Buffer.isBuffer(data)) ; else if (utils.isArrayBuffer(data)) {
        data = Buffer.from(new Uint8Array(data));
      } else if (utils.isString(data)) {
        data = Buffer.from(data, 'utf-8');
      } else {
        return reject(createError(
          'Data after transformation must be a string, an ArrayBuffer, a Buffer, or a Stream',
          config
        ));
      }

      if (config.maxBodyLength > -1 && data.length > config.maxBodyLength) {
        return reject(createError('Request body larger than maxBodyLength limit', config));
      }

      // Add Content-Length header if data exists
      if (!headerNames['content-length']) {
        headers['Content-Length'] = data.length;
      }
    }

    // HTTP basic authentication
    var auth = undefined;
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      auth = username + ':' + password;
    }

    // Parse url
    var fullPath = buildFullPath(config.baseURL, config.url);
    var parsed = url__default["default"].parse(fullPath);
    var protocol = parsed.protocol || 'http:';

    if (!auth && parsed.auth) {
      var urlAuth = parsed.auth.split(':');
      var urlUsername = urlAuth[0] || '';
      var urlPassword = urlAuth[1] || '';
      auth = urlUsername + ':' + urlPassword;
    }

    if (auth && headerNames.authorization) {
      delete headers[headerNames.authorization];
    }

    var isHttpsRequest = isHttps.test(protocol);
    var agent = isHttpsRequest ? config.httpsAgent : config.httpAgent;

    try {
      buildURL(parsed.path, config.params, config.paramsSerializer).replace(/^\?/, '');
    } catch (err) {
      var customErr = new Error(err.message);
      customErr.config = config;
      customErr.url = config.url;
      customErr.exists = true;
      reject(customErr);
    }

    var options = {
      path: buildURL(parsed.path, config.params, config.paramsSerializer).replace(/^\?/, ''),
      method: config.method.toUpperCase(),
      headers: headers,
      agent: agent,
      agents: { http: config.httpAgent, https: config.httpsAgent },
      auth: auth
    };

    if (config.socketPath) {
      options.socketPath = config.socketPath;
    } else {
      options.hostname = parsed.hostname;
      options.port = parsed.port;
    }

    var proxy = config.proxy;
    if (!proxy && proxy !== false) {
      var proxyEnv = protocol.slice(0, -1) + '_proxy';
      var proxyUrl = process.env[proxyEnv] || process.env[proxyEnv.toUpperCase()];
      if (proxyUrl) {
        var parsedProxyUrl = url__default["default"].parse(proxyUrl);
        var noProxyEnv = process.env.no_proxy || process.env.NO_PROXY;
        var shouldProxy = true;

        if (noProxyEnv) {
          var noProxy = noProxyEnv.split(',').map(function trim(s) {
            return s.trim();
          });

          shouldProxy = !noProxy.some(function proxyMatch(proxyElement) {
            if (!proxyElement) {
              return false;
            }
            if (proxyElement === '*') {
              return true;
            }
            if (proxyElement[0] === '.' &&
                parsed.hostname.substr(parsed.hostname.length - proxyElement.length) === proxyElement) {
              return true;
            }

            return parsed.hostname === proxyElement;
          });
        }

        if (shouldProxy) {
          proxy = {
            host: parsedProxyUrl.hostname,
            port: parsedProxyUrl.port,
            protocol: parsedProxyUrl.protocol
          };

          if (parsedProxyUrl.auth) {
            var proxyUrlAuth = parsedProxyUrl.auth.split(':');
            proxy.auth = {
              username: proxyUrlAuth[0],
              password: proxyUrlAuth[1]
            };
          }
        }
      }
    }

    if (proxy) {
      options.headers.host = parsed.hostname + (parsed.port ? ':' + parsed.port : '');
      setProxy(options, proxy, protocol + '//' + parsed.hostname + (parsed.port ? ':' + parsed.port : '') + options.path);
    }

    var transport;
    var isHttpsProxy = isHttpsRequest && (proxy ? isHttps.test(proxy.protocol) : true);
    if (config.transport) {
      transport = config.transport;
    } else if (config.maxRedirects === 0) {
      transport = isHttpsProxy ? https__default["default"] : http__default["default"];
    } else {
      if (config.maxRedirects) {
        options.maxRedirects = config.maxRedirects;
      }
      transport = isHttpsProxy ? httpsFollow : httpFollow;
    }

    if (config.maxBodyLength > -1) {
      options.maxBodyLength = config.maxBodyLength;
    }

    if (config.insecureHTTPParser) {
      options.insecureHTTPParser = config.insecureHTTPParser;
    }

    // Create the request
    var req = transport.request(options, function handleResponse(res) {
      if (req.aborted) return;

      // uncompress the response body transparently if required
      var stream = res;

      // return the last request in case of redirects
      var lastRequest = res.req || req;


      // if no content, is HEAD request or decompress disabled we should not decompress
      if (res.statusCode !== 204 && lastRequest.method !== 'HEAD' && config.decompress !== false) {
        switch (res.headers['content-encoding']) {
        /*eslint default-case:0*/
        case 'gzip':
        case 'compress':
        case 'deflate':
        // add the unzipper to the body stream processing pipeline
          stream = stream.pipe(zlib__default["default"].createUnzip());

          // remove the content-encoding in order to not confuse downstream operations
          delete res.headers['content-encoding'];
          break;
        }
      }

      var response = {
        status: res.statusCode,
        statusText: res.statusMessage,
        headers: res.headers,
        config: config,
        request: lastRequest
      };

      if (config.responseType === 'stream') {
        response.data = stream;
        settle(resolve, reject, response);
      } else {
        var responseBuffer = [];
        var totalResponseBytes = 0;
        stream.on('data', function handleStreamData(chunk) {
          responseBuffer.push(chunk);
          totalResponseBytes += chunk.length;

          // make sure the content length is not over the maxContentLength if specified
          if (config.maxContentLength > -1 && totalResponseBytes > config.maxContentLength) {
            // stream.destoy() emit aborted event before calling reject() on Node.js v16
            rejected = true;
            stream.destroy();
            reject(createError('maxContentLength size of ' + config.maxContentLength + ' exceeded',
              config, null, lastRequest));
          }
        });

        stream.on('aborted', function handlerStreamAborted() {
          if (rejected) {
            return;
          }
          stream.destroy();
          reject(createError('error request aborted', config, 'ERR_REQUEST_ABORTED', lastRequest));
        });

        stream.on('error', function handleStreamError(err) {
          if (req.aborted) return;
          reject(enhanceError(err, config, null, lastRequest));
        });

        stream.on('end', function handleStreamEnd() {
          try {
            var responseData = responseBuffer.length === 1 ? responseBuffer[0] : Buffer.concat(responseBuffer);
            if (config.responseType !== 'arraybuffer') {
              responseData = responseData.toString(config.responseEncoding);
              if (!config.responseEncoding || config.responseEncoding === 'utf8') {
                responseData = utils.stripBOM(responseData);
              }
            }
            response.data = responseData;
          } catch (err) {
            reject(enhanceError(err, config, err.code, response.request, response));
          }
          settle(resolve, reject, response);
        });
      }
    });

    // Handle errors
    req.on('error', function handleRequestError(err) {
      if (req.aborted && err.code !== 'ERR_FR_TOO_MANY_REDIRECTS') return;
      reject(enhanceError(err, config, null, req));
    });

    // set tcp keep alive to prevent drop connection by peer
    req.on('socket', function handleRequestSocket(socket) {
      // default interval of sending ack packet is 1 minute
      socket.setKeepAlive(true, 1000 * 60);
    });

    // Handle request timeout
    if (config.timeout) {
      // This is forcing a int timeout to avoid problems if the `req` interface doesn't handle other types.
      var timeout = parseInt(config.timeout, 10);

      if (isNaN(timeout)) {
        reject(createError(
          'error trying to parse `config.timeout` to int',
          config,
          'ERR_PARSE_TIMEOUT',
          req
        ));

        return;
      }

      // Sometime, the response will be very slow, and does not respond, the connect event will be block by event loop system.
      // And timer callback will be fired, and abort() will be invoked before connection, then get "socket hang up" and code ECONNRESET.
      // At this time, if we have a large number of request, nodejs will hang up some socket on background. and the number will up and up.
      // And then these socket which be hang up will devoring CPU little by little.
      // ClientRequest.setTimeout will be fired on the specify milliseconds, and can make sure that abort() will be fired after connect.
      req.setTimeout(timeout, function handleRequestTimeout() {
        req.abort();
        var timeoutErrorMessage = '';
        if (config.timeoutErrorMessage) {
          timeoutErrorMessage = config.timeoutErrorMessage;
        } else {
          timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
        }
        var transitional$1 = config.transitional || transitional;
        reject(createError(
          timeoutErrorMessage,
          config,
          transitional$1.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
          req
        ));
      });
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (req.aborted) return;

        req.abort();
        reject(!cancel || (cancel && cancel.type) ? new Cancel_1('canceled') : cancel);
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }


    // Send the request
    if (utils.isStream(data)) {
      data.on('error', function handleStreamError(err) {
        reject(enhanceError(err, config, null, req));
      }).pipe(req);
    } else {
      req.end(data);
    }
  });
};

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = xhr;
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = http_1;
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: transitional,

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

var defaults_1 = defaults;

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
var transformData = function transformData(data, headers, fns) {
  var context = this || defaults_1;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};

var isCancel = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new Cancel_1('canceled');
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
var dispatchRequest = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults_1.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
var mergeConfig = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};

var VERSION = data.version;

var validators$1 = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators$1[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators$1.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

var validator = {
  assertOptions: assertOptions,
  validators: validators$1
};

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager_1(),
    response: new InterceptorManager_1()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(configOrUrl, config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof configOrUrl === 'string') {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

var Axios_1 = Axios;

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel_1(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

var CancelToken_1 = CancelToken;

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
var spread = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
var isAxiosError = function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
};

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios_1(defaultConfig);
  var instance = bind(Axios_1.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios_1.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios$1 = createInstance(defaults_1);

// Expose Axios class to allow class inheritance
axios$1.Axios = Axios_1;

// Expose Cancel & CancelToken
axios$1.Cancel = Cancel_1;
axios$1.CancelToken = CancelToken_1;
axios$1.isCancel = isCancel;
axios$1.VERSION = data.version;

// Expose all/spread
axios$1.all = function all(promises) {
  return Promise.all(promises);
};
axios$1.spread = spread;

// Expose isAxiosError
axios$1.isAxiosError = isAxiosError;

var axios_1 = axios$1;

// Allow use of default import syntax in TypeScript
var _default = axios$1;
axios_1.default = _default;

var axios = axios_1;

var emptyCredential = {
    authentication: null,
    token: null,
    refreshToken: null,
    missingConsents: null,
};

var getAccessTokenFromHeaders = function (headers) { return headers.authorization; };
var getRefreshTokenFromHeaders = function (headers) { return headers[refreshTokenHeader]; };
var getIsTrustedDeviceFromHeaders = function (headers) {
    return headers[isTrustedDeviceHeader] === 'true';
};
var getMissingConsentsFromHeaders = function (headers) { return headers[missingConsentsHeader]; };

var defaultHadesSettings = {
    serverUrl: productionHades,
};
var hades = typeof window !== 'undefined' ? window.hades || defaultHadesSettings : defaultHadesSettings;
var http = axios.create({
    baseURL: hades.serverUrl,
    withCredentials: true,
});
/* Redirects to the Google OAuth flow.
 *
 * @param redirectUri - The URI to redirect after login.
 */
var loginWithGoogle = function (redirectUri) {
    if (redirectUri === void 0) { redirectUri = window.location.origin; }
    var encodedUri = decodeURIComponent(redirectUri);
    window.location.href = window.hades.serverUrl + "/api/authenticate?redirect_uri=" + encodedUri;
};
/* Log in with e-mail and password
 */
var loginWithEmailAndPassword = function (credentials) { return __awaiter(void 0, void 0, void 0, function () {
    var trustedDeviceId, _a, data, headers;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                trustedDeviceId = JSON.parse(getItem(trustedDeviceStorageKey));
                return [4 /*yield*/, http.post('/api/authenticate', __assign(__assign({}, credentials), (trustedDeviceId && { trustedDeviceId: trustedDeviceId })))];
            case 1:
                _a = _b.sent(), data = _a.data, headers = _a.headers;
                return [2 /*return*/, {
                        token: getAccessTokenFromHeaders(headers),
                        refreshToken: getRefreshTokenFromHeaders(headers),
                        isTrustedDevice: getIsTrustedDeviceFromHeaders(headers),
                        user: data,
                    }];
        }
    });
}); };
/* Logout with reason / kind */
var logout = function (_a) {
    var token = _a.token, kind = _a.kind;
    return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, http.post("/api/authenticate/logout?logoutReason=" + kind, {}, { headers: { Authorization: token } })
                /* Get the user data and token
                 *
                 * @param sessionId - The sessionId value received after the OAuth flow
                 */
            ];
            case 1: return [2 /*return*/, _b.sent()
                /* Get the user data and token
                 *
                 * @param sessionId - The sessionId value received after the OAuth flow
                 */
            ];
        }
    }); });
};
/* Get the user data and token
 *
 * @param sessionId - The sessionId value received after the OAuth flow
 */
var authenticateComplete = function (sessionId) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, user, headers, e_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, http.get('/api/authenticate/complete', {
                        headers: {
                            SESSION: sessionId,
                        },
                    })];
            case 1:
                _a = _b.sent(), user = _a.data, headers = _a.headers;
                return [2 /*return*/, {
                        token: getAccessTokenFromHeaders(headers),
                        refreshToken: getRefreshTokenFromHeaders(headers),
                        user: user,
                    }];
            case 2:
                e_1 = _b.sent();
                return [2 /*return*/, Promise.reject(e_1.response.data)];
            case 3: return [2 /*return*/];
        }
    });
}); };
/* Get the potential patient email, patientRegistrationSource and preferredLanguageCode
 *
 * @param token - A valid JWT token
 */
var postEnrollments = function (fields) { return __awaiter(void 0, void 0, void 0, function () {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, http.post("/api/users/patient/v2/register/short/enrollments", fields)];
            case 1:
                data = _a.sent();
                return [2 /*return*/, data.data];
        }
    });
}); };
/* Get the user for the current token
 *
 * @param token - A valid JWT token
 */
var getCurrentUser = function (token) { return __awaiter(void 0, void 0, void 0, function () {
    var data, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, http.get('/api/users/current', {
                        headers: {
                            Authorization: token,
                        },
                    })];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
            case 2:
                e_2 = _a.sent();
                return [2 /*return*/, Promise.reject(e_2.response.data)];
            case 3: return [2 /*return*/];
        }
    });
}); };
/* Remove the credentials from localStorage.
 */
var clearAuth = function () {
    localStorage.setItem(authStorageKey, JSON.stringify(emptyCredential));
};
var getToken = function (refreshToken) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, user, headers;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, http.post('/api/authenticate/token', {
                    token: refreshToken,
                })];
            case 1:
                _a = _b.sent(), user = _a.data, headers = _a.headers;
                return [2 /*return*/, {
                        token: getAccessTokenFromHeaders(headers),
                        refreshToken: getRefreshTokenFromHeaders(headers),
                        user: user,
                    }];
        }
    });
}); };
var getRefreshedCredential = function (_a) {
    var token = _a.token, user = _a.user;
    var currentCredentials = localStorage.getItem(authStorageKey);
    try {
        var parsedCredentials = JSON.parse(currentCredentials);
        return __assign(__assign({}, parsedCredentials), { user: user,
            token: token });
    }
    catch (e) {
        return { user: user, token: token };
    }
};
var persistCredential = function (credential) {
    localStorage.setItem(authStorageKey, JSON.stringify(credential));
    return credential;
};
var dispatchCredential = function (credential) {
    // We dispatch a custom event so the React tree can capture the new credential and update the security provider state
    window.dispatchEvent(new CustomEvent(credentialEvent, { detail: credential }));
    return credential;
};
var getCredentials = function () {
    var credentials = getItem(authStorageKey);
    try {
        if (credentials) {
            var parsedCredentials = JSON.parse(credentials);
            if (parsedCredentials)
                return parsedCredentials;
        }
        else {
            return {
                token: null,
                refreshToken: null,
                authentication: null,
                missingConsents: null,
            };
        }
    }
    catch (e) {
        return null;
    }
};
var loginPath = function (win) {
    var _a, _b, _c, _d, _e, _f;
    var isHashHistory = ((_a = win === null || win === void 0 ? void 0 : win.location) === null || _a === void 0 ? void 0 : _a.hash) !== '';
    return isHashHistory && ((_b = win === null || win === void 0 ? void 0 : win.hades) === null || _b === void 0 ? void 0 : _b.loginPath)
        ? "#" + ((_d = (_c = win === null || win === void 0 ? void 0 : win.hades) === null || _c === void 0 ? void 0 : _c.loginPath) !== null && _d !== void 0 ? _d : '/login')
        : (_f = (_e = win === null || win === void 0 ? void 0 : win.hades) === null || _e === void 0 ? void 0 : _e.loginPath) !== null && _f !== void 0 ? _f : '/login';
};
var refreshCredential = function (refreshToken) {
    return getToken(refreshToken).then(getRefreshedCredential).then(persistCredential).then(dispatchCredential);
};
/* Intercepts the axios requests and add the token.
 */
var requestInterceptor = function (config) { return __awaiter(void 0, void 0, void 0, function () {
    var controller, abortAndRedirect, auth, token;
    return __generator(this, function (_a) {
        controller = new AbortController();
        abortAndRedirect = function () {
            controller.abort();
            if (window) {
                window.location.href = "" + window.location.origin + loginPath(window);
            }
        };
        try {
            auth = getItem(authStorageKey);
            if (auth) {
                token = JSON.parse(auth).token;
                if (token) {
                    config.headers['authorization'] = token;
                }
                else {
                    abortAndRedirect();
                }
            }
            else {
                abortAndRedirect();
            }
        }
        catch (e) { }
        return [2 /*return*/, __assign(__assign({}, config), { signal: controller.signal })];
    });
}); };
/* Intercepts the axios response error.
 */
var responseErrorInterceptor = function (error) { return __awaiter(void 0, void 0, void 0, function () {
    var config, auth, refreshToken, newToken;
    var _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                if (!(((_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.status) === 401)) return [3 /*break*/, 8];
                config = error.config;
                _d.label = 1;
            case 1:
                _d.trys.push([1, 7, , 8]);
                auth = getItem(authStorageKey);
                if (!auth) return [3 /*break*/, 6];
                refreshToken = JSON.parse(auth).refreshToken;
                if (!refreshToken) return [3 /*break*/, 6];
                _d.label = 2;
            case 2:
                _d.trys.push([2, 4, , 5]);
                return [4 /*yield*/, refreshCredential(refreshToken)];
            case 3:
                newToken = (_d.sent()).token;
                config.headers['authorization'] = newToken;
                return [3 /*break*/, 5];
            case 4:
                _d.sent();
                clearAuth();
                if (window)
                    window.location.href = "" + window.location.origin + loginPath(window) + "?error=session_expired";
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/, axios(config)];
            case 6: return [3 /*break*/, 8];
            case 7:
                _d.sent();
                return [3 /*break*/, 8];
            case 8:
                if (window && ((_c = error === null || error === void 0 ? void 0 : error.response) === null || _c === void 0 ? void 0 : _c.status) === 401) {
                    window.location.href = "" + window.location.origin + loginPath(window);
                }
                return [2 /*return*/, Promise.reject(error)];
        }
    });
}); };
var hadesRequestInterceptor = function (config) {
    config.baseURL = window.hades.serverUrl;
    if (window.hades.u_s) {
        config.headers = __assign(__assign({}, config.headers), { u_s: window.hades.u_s });
    }
    return config;
};
http.interceptors.request.use(hadesRequestInterceptor);
/* Add the requestInterceptor and responseErrorInterceptor to an axios instance
 */
var addAuthInterceptors = function (axiosInstance) {
    axiosInstance.interceptors.request.use(requestInterceptor);
    axiosInstance.interceptors.response.use(function (config) { return config; }, responseErrorInterceptor);
};
/**
 * Two Factor Authentication
 */
var twoFactorVerification = function (body) { return __awaiter(void 0, void 0, void 0, function () {
    var credentials, _a, data, headers, e_4;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                credentials = getCredentials();
                return [4 /*yield*/, http.post('/api/authenticate/verify', body, {
                        headers: {
                            Authorization: credentials === null || credentials === void 0 ? void 0 : credentials.token,
                        },
                    })];
            case 1:
                _a = _b.sent(), data = _a.data, headers = _a.headers;
                return [2 /*return*/, {
                        token: getAccessTokenFromHeaders(headers),
                        refreshToken: getRefreshTokenFromHeaders(headers),
                        missingConsents: getMissingConsentsFromHeaders(headers),
                        trustedDeviceId: data.trustedDeviceId,
                        user: data,
                    }];
            case 2:
                e_4 = _b.sent();
                return [2 /*return*/, Promise.reject(e_4.response.data)];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * User registration
 */
var postRegisterUser = function (body) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, e_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, http.post('/api/users/patient/v2/register', body)];
            case 1:
                headers = (_a.sent()).headers;
                return [2 /*return*/, {
                        token: getAccessTokenFromHeaders(headers),
                    }];
            case 2:
                e_5 = _a.sent();
                return [2 /*return*/, Promise.reject(__assign(__assign({}, e_5.response.data), { payload: JSON.parse(e_5.config.data) }))];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * User token-based registration
 */
var postShortRegisterUser = function (_a) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, e_6;
    var token = _a.token, body = __rest(_a, ["token"]);
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, http.post("/api/users/patient/v2/register/short/" + token, body)];
            case 1:
                headers = (_b.sent()).headers;
                return [2 /*return*/, {
                        token: getAccessTokenFromHeaders(headers),
                    }];
            case 2:
                e_6 = _b.sent();
                return [2 /*return*/, Promise.reject(__assign(__assign({}, e_6.response.data), { payload: JSON.parse(e_6.config.data) }))];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * Patient language amendment
 */
var patchSetPreferredLanguage = function (_a) {
    var languageCode = _a.languageCode, referenceId = _a.referenceId;
    return __awaiter(void 0, void 0, void 0, function () {
        var token, data, e_7, errorMessage;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    token = getCredentials().token;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, http.patch("/api/users/patient/" + referenceId + "/language", { languageCode: languageCode }, {
                            headers: {
                                Authorization: token,
                            },
                        })];
                case 2:
                    data = (_b.sent()).data;
                    return [2 /*return*/, data];
                case 3:
                    e_7 = _b.sent();
                    errorMessage = e_7.response.data || 'generic_error';
                    return [2 /*return*/, Promise.reject(errorMessage)];
                case 4: return [2 /*return*/];
            }
        });
    });
};
/**
 * Verify Phone
 */
var postVerifyPhone = function (body) { return __awaiter(void 0, void 0, void 0, function () {
    var token, _a, data, headers, e_8;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                token = getCredentials().token;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, http.post('/api/users/patient/v2/register/phone', body, {
                        headers: {
                            Authorization: token,
                        },
                    })];
            case 2:
                _a = _b.sent(), data = _a.data, headers = _a.headers;
                return [2 /*return*/, {
                        refreshToken: getRefreshTokenFromHeaders(headers),
                        token: getAccessTokenFromHeaders(headers),
                        trustedDeviceId: data.trustedDeviceId,
                        user: data,
                    }];
            case 3:
                e_8 = _b.sent();
                return [2 /*return*/, Promise.reject(e_8.response.data)];
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * Verify Phone Reset
 */
var postVerifyPhoneReset = function (body) { return __awaiter(void 0, void 0, void 0, function () {
    var patientUsernameAndPasswordToken, token, restOfBody, _a, data, headers, e_9;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                patientUsernameAndPasswordToken = getCredentials().token;
                token = body.token, restOfBody = __rest(body, ["token"]);
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, http.post('/api/users/patient/reset-phone-number/verify-phone', __assign(__assign({}, restOfBody), { patientUsernameAndPasswordToken: patientUsernameAndPasswordToken }), {
                        headers: {
                            Authorization: token,
                        },
                    })];
            case 2:
                _a = _b.sent(), data = _a.data, headers = _a.headers;
                return [2 /*return*/, {
                        refreshToken: getRefreshTokenFromHeaders(headers),
                        token: getAccessTokenFromHeaders(headers),
                        user: data,
                    }];
            case 3:
                e_9 = _b.sent();
                return [2 /*return*/, Promise.reject(e_9.response.data)];
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * Verify email
 */
var postVerifyEmail = function (token, mobileToken) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, data, headers;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, http.post("/api/users/patient/v2/register/" + token, mobileToken
                    ? {
                        mobileToken: mobileToken,
                    }
                    : undefined)];
            case 1:
                _a = _b.sent(), data = _a.data, headers = _a.headers;
                return [2 /*return*/, {
                        user: data,
                        token: getAccessTokenFromHeaders(headers),
                        refreshToken: getRefreshTokenFromHeaders(headers),
                    }];
        }
    });
}); };
/**
 * Forgot password
 */
var postResetPasswordInitialization = function (body) { return __awaiter(void 0, void 0, void 0, function () {
    var data, e_10, errorMessage;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, http.post('/api/users/patient/reset-password', body)];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
            case 2:
                e_10 = _a.sent();
                errorMessage = e_10.response.data || 'generic_error';
                return [2 /*return*/, Promise.reject(errorMessage)];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * Other phone number
 */
var postResetPhoneNumberInitialization = function (body) { return __awaiter(void 0, void 0, void 0, function () {
    var token, data, e_11, errorMessage;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                token = getCredentials().token;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, http.post('/api/users/patient/reset-phone-number', body, {
                        headers: { Authorization: token },
                    })];
            case 2:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
            case 3:
                e_11 = _a.sent();
                errorMessage = e_11.response.data || 'generic_error';
                return [2 /*return*/, Promise.reject(errorMessage)];
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * Verification code resending
 */
var postResendVerificationCode = function () { return __awaiter(void 0, void 0, void 0, function () {
    var token, authorization, e_12, errorMessage;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                token = getCredentials().token;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, http.post('/api/users/patient/v2/register/resend-verification-code', undefined, {
                        headers: { Authorization: token },
                    })];
            case 2:
                authorization = (_a.sent()).headers.authorization;
                return [2 /*return*/, authorization];
            case 3:
                e_12 = _a.sent();
                errorMessage = e_12.response.data || 'generic_error';
                return [2 /*return*/, Promise.reject(errorMessage)];
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * Verification email resending
 */
var postResendVerificationEmail = function () { return __awaiter(void 0, void 0, void 0, function () {
    var token, data, e_13, errorMessage;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                token = getCredentials().token;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, http.post('/api/users/patient/v2/register/resend-verification-email', undefined, {
                        headers: { Authorization: token },
                    })];
            case 2:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
            case 3:
                e_13 = _a.sent();
                errorMessage = e_13.response.data || 'generic_error';
                return [2 /*return*/, Promise.reject(errorMessage)];
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * Check the validity of the reset password token
 */
var getCheckResetPasswordToken = function (body) { return __awaiter(void 0, void 0, void 0, function () {
    var data, e_14, errorMessage;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, http.get("/api/users/patient/reset-password/" + body.token)];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
            case 2:
                e_14 = _a.sent();
                errorMessage = e_14.response.data || 'generic_error';
                return [2 /*return*/, Promise.reject(errorMessage)];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * Check the validity of the reset phone number token
 */
var getCheckResetPhoneNumberToken = function (body) { return __awaiter(void 0, void 0, void 0, function () {
    var data, e_15, errorMessage;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, http.get("/api/users/patient/reset-phone-number/" + (body === null || body === void 0 ? void 0 : body.token) + "/validate")];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
            case 2:
                e_15 = _a.sent();
                errorMessage = e_15.response.data || 'generic_error';
                return [2 /*return*/, Promise.reject(errorMessage)];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * Reset password
 */
var putResetPassword = function (body) { return __awaiter(void 0, void 0, void 0, function () {
    var data, e_16, errorMessage;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, http.put('/api/users/patient/reset-password', { newPassword: body === null || body === void 0 ? void 0 : body.newPassword }, {
                        headers: {
                            Authorization: body.token,
                        },
                    })];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
            case 2:
                e_16 = _a.sent();
                errorMessage = e_16.response.data || 'generic_error';
                return [2 /*return*/, Promise.reject(errorMessage)];
            case 3: return [2 /*return*/];
        }
    });
}); };
/**
 * Reset phone number
 */
var postResetPhoneNumber = function (body) { return __awaiter(void 0, void 0, void 0, function () {
    var headers, e_17, errorMessage;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, http.post("/api/users/patient/reset-phone-number/submit", { newPhoneNumber: body === null || body === void 0 ? void 0 : body.newPhoneNumber }, {
                        headers: {
                            Authorization: body.token,
                        },
                    })];
            case 1:
                headers = (_a.sent()).headers;
                return [2 /*return*/, {
                        token: getAccessTokenFromHeaders(headers),
                    }];
            case 2:
                e_17 = _a.sent();
                errorMessage = e_17.response.data || 'generic_error';
                return [2 /*return*/, Promise.reject(errorMessage)];
            case 3: return [2 /*return*/];
        }
    });
}); };
/*
 * Missing Consent
 */
var postMissingConsents = function (body) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, token, authentication, personReferenceId, _b, data, headers, e_18, errorMessage;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = getCredentials(), token = _a.token, authentication = _a.authentication;
                personReferenceId = authentication === null || authentication === void 0 ? void 0 : authentication.personReferenceId;
                _c.label = 1;
            case 1:
                _c.trys.push([1, 3, , 4]);
                return [4 /*yield*/, http.post('/api/users/patient/consents', __assign({ personReferenceId: personReferenceId }, body), {
                        headers: {
                            Authorization: token,
                        },
                    })];
            case 2:
                _b = _c.sent(), data = _b.data, headers = _b.headers;
                return [2 /*return*/, {
                        token: getAccessTokenFromHeaders(headers),
                        refreshToken: getRefreshTokenFromHeaders(headers),
                        missingConsents: getMissingConsentsFromHeaders(headers),
                        user: data,
                    }];
            case 3:
                e_18 = _c.sent();
                errorMessage = e_18.response.data || 'generic_error';
                return [2 /*return*/, Promise.reject(errorMessage)];
            case 4: return [2 /*return*/];
        }
    });
}); };

/* Decode a JWT token */
var decodeToken = function (token) {
    var payload = token.split('.')[1];
    if (payload) {
        try {
            var decoded = atob(payload);
            return JSON.parse(decoded);
        }
        catch (e) {
            console.log(e);
            return;
        }
    }
    return;
};
var getTokenRemainingTimeToExpireInMs = function (token) {
    var decodedToken = decodeToken(token);
    var now = Date.now();
    var tokenExpiresAtInMs = decodedToken.exp * 1000;
    var timeRemainingInMs = tokenExpiresAtInMs - now;
    return timeRemainingInMs;
};
/* Check if a token is valid. Will return false if the token can't be decoded
 * or if it's expired.
 */
var isTokenValid = function (token) {
    var decodedToken = decodeToken(token);
    var now = Date.now();
    if (!decodedToken) {
        return false;
    }
    var exp = decodedToken.exp;
    return exp * 1000 >= now;
};
var isPartial = function (token) {
    var decodedToken = decodeToken(token);
    if (!decodedToken) {
        return false;
    }
    return decodedToken === null || decodedToken === void 0 ? void 0 : decodedToken.partial;
};

var useTokenRefresh = function () {
    var credentials = useCredentials();
    var setCredentials = useSetCredentials();
    React.useEffect(function () {
        var timeoutId = null;
        if (credentials.refreshToken && credentials.token) {
            var decodedToken = decodeToken(credentials.token);
            if (decodedToken) {
                var timeRemainingToExpire = getTokenRemainingTimeToExpireInMs(credentials.token);
                var timeToRefresh = timeRemainingToExpire - refreshTokenThreshold;
                timeoutId = setTimeout(function () {
                    refreshCredential(credentials.refreshToken);
                }, timeToRefresh);
            }
        }
        return function () {
            clearTimeout(timeoutId);
        };
    }, [credentials.token, credentials.refreshToken]);
    React.useEffect(function () {
        var handleStorageChange = function (_a) {
            var detail = _a.detail;
            var user = detail.user, token = detail.token, refreshToken = detail.refreshToken;
            setCredentials({ authentication: user, token: token, refreshToken: refreshToken }, 'local');
        };
        window.addEventListener(credentialEvent, handleStorageChange);
        return function () { return window.removeEventListener(credentialEvent, handleStorageChange); };
    }, [setCredentials]);
};

// We chose to use cookies to save the redirect url in order to make the
// saved redirect expire when the user closes the browser in case we forget
// to remove it.
//
//
var saveRedirect = function (location, securityConfig) {
    var locationJson = JSON.stringify({
        pathname: location.pathname,
        search: location.search,
    });
    if (location.search || location.pathname !== securityConfig.successPath) {
        try {
            sessionStorage.setItem(redirectCookieKey, locationJson);
        }
        catch (e) { }
    }
};
var getRedirect = function () {
    try {
        return JSON.parse(sessionStorage.getItem(redirectCookieKey));
    }
    catch (e) { }
};
var deleteRedirect = function () {
    try {
        sessionStorage.removeItem(redirectCookieKey);
    }
    catch (e) { }
};
var redirectService = {
    saveRedirect: saveRedirect,
    getRedirect: getRedirect,
    deleteRedirect: deleteRedirect,
};

/* Check if a user have access to an application, returns true if the
 * user have acess to the application.
 *
 * @param application - The application name
 * @param user - The user to have the credentials checked
 */
var hasAccessToTheApplication = function (application, user) {
    var _a;
    if (!((_a = user === null || user === void 0 ? void 0 : user.roles) === null || _a === void 0 ? void 0 : _a.length))
        return false;
    return user.roles
        .flatMap(function (roleForClinics) { return roleForClinics.role.applicationPermissions; })
        .some(function (applicationPermission) { return applicationPermission.application === application; });
};
/* Check if a user have access to a view, returns true if the
 * user have access to the view.
 *
 * @param application - The application name
 * @param view - The view name
 * @param user - The user to have the credentials checked
 */
var hasAccessToTheView = function (application, view, user) {
    return (user.roles
        .flatMap(function (roleForClinics) { return roleForClinics.role.applicationPermissions; })
        .some(function (grantedPermission) { return grantedPermission.view === view && grantedPermission.application === application; }) ||
        false);
};

var initialRouter = typeof window !== 'undefined'
    ? {
        origin: window.location.origin,
        hash: window.location.hash,
        search: window.location.search,
        pathname: window.location.pathname,
        redirect: function (url) { return (window.location.href = url); },
        push: function (url) { return window.history.pushState(null, window.document.title, url); },
    }
    : {
        hash: '',
        origin: '',
        search: '',
        pathname: '/',
        redirect: function () { },
        push: function () { },
    };
var RouterContext = React.createContext(initialRouter);
var RouterProvider = function (_a) {
    var value = _a.value, children = _a.children;
    return React__default["default"].createElement(RouterContext.Provider, { value: value }, children);
};
var useRouter = function () {
    var context = React.useContext(RouterContext);
    if (context === undefined)
        throw new Error('`useRouter` must be used within `RouterProvider`');
    return context;
};

var Redirect = function (_a) {
    var to = _a.to;
    var router = useRouter();
    React.useEffect(function () {
        var link = typeof to === 'string' ? to : to === null || to === void 0 ? void 0 : to.pathname;
        router.push(link);
    }, []);
    return React__default["default"].createElement(React__default["default"].Fragment, null);
};

var defaultRedirectUri = typeof window !== 'undefined' ? "" + (window === null || window === void 0 ? void 0 : window.location.origin) + (window === null || window === void 0 ? void 0 : window.location.pathname) : '';
var defaultSecurityConfig = {
    redirectUri: defaultRedirectUri,
    loginPath: '/login',
    successPath: '/',
    twoFactorAuthPath: '/mfa',
    phoneVerificationPath: '/verifyphone',
    emailVerificationPath: '/verifyemail',
    missingConsentsPath: '/renew-consent',
    loading: 'Loading...',
    env: 'production',
};
var SecurityConfigContext = React.createContext(defaultSecurityConfig);
var SecurityConfigProvider = function (_a) {
    var children = _a.children, _b = _a.value, value = _b === void 0 ? {} : _b;
    var serverUrl = React.useMemo(function () {
        if (value.endpoint)
            return value.endpoint;
        if (value.env === 'development') {
            throw new Error('You need to pass the `endpoint` when the environment is `development`.');
        }
        return value.env === 'production' ? productionHades : stagingHades;
    }, [value]);
    React.useEffect(function () {
        window.hades = {
            serverUrl: serverUrl,
            loginPath: value.loginPath || defaultSecurityConfig.loginPath,
            u_s: value.u_s,
        };
    }, [value]);
    return (React__default["default"].createElement(SecurityConfigContext.Provider, { value: __assign(__assign({}, defaultSecurityConfig), value) }, children));
};
var useSecurityConfig = function () {
    var context = React.useContext(SecurityConfigContext);
    if (!context) {
        throw new Error('useSecurityConfigContext must be used within the securityProvider');
    }
    return context;
};

var AuthenticationHandler = function (_a) {
    var children = _a.children;
    var securityConfig = useSecurityConfig();
    var router = useRouter();
    var security = useCredentials();
    var setSecurity = useSetCredentials();
    var _b = React.useState(), error = _b[0], setError = _b[1];
    var isClientPresent = typeof window !== 'undefined';
    useTokenRefresh();
    var mustCheckApplicationPermission = Boolean(securityConfig.application);
    var haveCredentials = Boolean(security.token);
    var refreshTokenExists = Boolean(security.refreshToken);
    var tokenHasExpired = refreshTokenExists && !isTokenValid(security.refreshToken || '') && !isTokenValid(security.token);
    var _c = queryString.parse(isClientPresent ? window.location.search : router.search), sessionId = _c.sid, jwt = _c.jwt, queryParams = __rest(_c, ["sid", "jwt"]);
    var saveRedirect = function () {
        redirectService.saveRedirect({
            pathname: router.pathname,
            search: router.search,
        }, securityConfig);
    };
    var token = React.useMemo(function () {
        if (!securityConfig.enableImpersonation)
            return;
        if (jwt && isClientPresent)
            localStorage.removeItem(authStorageKey);
        return jwt;
    }, [jwt]);
    var hash = typeof window !== 'undefined' ? window.location.hash : router.hash;
    var isHashHistory = hash !== '';
    var handleAuth = React.useCallback(function () {
        if (sessionId) {
            authenticateComplete(sessionId)
                .then(function (_a) {
                var user = _a.user, token = _a.token, refreshToken = _a.refreshToken;
                setSecurity({ authentication: user, token: token, refreshToken: refreshToken }, 'local');
                setError(undefined);
                var redirectLocationFromCookie = redirectService.getRedirect();
                if (isHashHistory) {
                    if (redirectLocationFromCookie) {
                        var url = router.origin + "/#" + redirectLocationFromCookie.pathname + redirectLocationFromCookie.search;
                        redirectService.deleteRedirect();
                        router.redirect(url);
                    }
                    else {
                        router.redirect(securityConfig.redirectUri);
                    }
                }
            })
                .catch(function (e) { return setError(e.message); });
            return;
        }
        if (token && typeof token === 'string') {
            getCurrentUser(token)
                .then(function (user) {
                setSecurity({ authentication: user, token: token, refreshToken: null }, 'session');
                setError(undefined);
                router.redirect(securityConfig.redirectUri);
            })
                .catch(function (e) {
                var _a;
                setError((_a = e.message) !== null && _a !== void 0 ? _a : 'invalid_token');
            });
            return;
        }
        // ignore `location.search` and dependencies to avoid infinite loop.
        // eslint-disable-next-line
    }, [setSecurity, token, sessionId]);
    React.useEffect(handleAuth, []);
    React.useEffect(function () {
        if (error) {
            localStorage.removeItem(authStorageKey);
            sessionStorage.removeItem(authStorageKey);
            saveRedirect();
            setSecurity(null, 'local');
        }
    }, [error]);
    React.useEffect(function () {
        if (jwt) {
            localStorage.removeItem(authStorageKey);
            setSecurity(null, 'local');
        }
    }, [jwt]);
    if (error) {
        return React__default["default"].createElement(Redirect, { to: securityConfig.loginPath + "?error=" + error });
    }
    if (token) {
        // Wait until handleAuth function result
        return React__default["default"].createElement(React__default["default"].Fragment, null, securityConfig.loading);
    }
    if (tokenHasExpired) {
        localStorage.removeItem(authStorageKey);
        saveRedirect();
        return React__default["default"].createElement(Redirect, { to: securityConfig.loginPath + "?error=session_expired" });
    }
    if (!haveCredentials && !sessionId && !token) {
        saveRedirect();
        return React__default["default"].createElement(Redirect, { to: securityConfig.loginPath });
    }
    if (security.token && isPartial(security.token) && !securityConfig.partiallyProtectedRoutes[router.pathname]) {
        saveRedirect();
        if (security.missingConsents) {
            return React__default["default"].createElement(Redirect, { to: securityConfig.missingConsentsPath });
        }
        return React__default["default"].createElement(Redirect, { to: securityConfig.twoFactorAuthPath });
    }
    if (sessionId && haveCredentials) {
        var redirectLocationFromCookie = redirectService.getRedirect();
        if (redirectLocationFromCookie) {
            return React__default["default"].createElement(Redirect, { to: redirectLocationFromCookie });
        }
        return React__default["default"].createElement(Redirect, { to: "" + securityConfig.successPath + queryString.stringify(queryParams) });
    }
    if (sessionId) {
        return React__default["default"].createElement(React__default["default"].Fragment, null, securityConfig.loading);
    }
    if (mustCheckApplicationPermission &&
        !hasAccessToTheApplication(securityConfig.application, security.authentication)) {
        return React__default["default"].createElement(Redirect, { to: securityConfig.loginPath + "?error=no_application_permission" });
    }
    return React__default["default"].createElement(React__default["default"].Fragment, null, children);
};

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}

function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}

var matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var htmlEntities = {
  '&amp;': '&',
  '&#38;': '&',
  '&lt;': '<',
  '&#60;': '<',
  '&gt;': '>',
  '&#62;': '>',
  '&apos;': "'",
  '&#39;': "'",
  '&quot;': '"',
  '&#34;': '"',
  '&nbsp;': ' ',
  '&#160;': ' ',
  '&copy;': '©',
  '&#169;': '©',
  '&reg;': '®',
  '&#174;': '®',
  '&hellip;': '…',
  '&#8230;': '…',
  '&#x2F;': '/',
  '&#47;': '/'
};

var unescapeHtmlEntity = function unescapeHtmlEntity(m) {
  return htmlEntities[m];
};

var unescape$1 = function unescape(text) {
  return text.replace(matchHtmlEntity, unescapeHtmlEntity);
};

var defaultOptions = {
  bindI18n: 'languageChanged',
  bindI18nStore: '',
  transEmptyNodeValue: '',
  transSupportBasicHtmlNodes: true,
  transWrapTextNodes: '',
  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  useSuspense: true,
  unescape: unescape$1
};
var i18nInstance$1;
var I18nContext = React.createContext();
function getDefaults() {
  return defaultOptions;
}
var ReportNamespaces = function () {
  function ReportNamespaces() {
    _classCallCheck(this, ReportNamespaces);

    this.usedNamespaces = {};
  }

  _createClass(ReportNamespaces, [{
    key: "addUsedNamespaces",
    value: function addUsedNamespaces(namespaces) {
      var _this = this;

      namespaces.forEach(function (ns) {
        if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function getUsedNamespaces() {
      return Object.keys(this.usedNamespaces);
    }
  }]);

  return ReportNamespaces;
}();
function getI18n() {
  return i18nInstance$1;
}

function warn() {
  if (console && console.warn) {
    var _console;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);

    (_console = console).warn.apply(_console, args);
  }
}
var alreadyWarned = {};
function warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
  warn.apply(void 0, args);
}
function loadNamespaces(i18n, ns, cb) {
  i18n.loadNamespaces(ns, function () {
    if (i18n.isInitialized) {
      cb();
    } else {
      var initialized = function initialized() {
        setTimeout(function () {
          i18n.off('initialized', initialized);
        }, 0);
        cb();
      };

      i18n.on('initialized', initialized);
    }
  });
}

function oldI18nextHasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var lng = i18n.languages[0];
  var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  var lastLng = i18n.languages[i18n.languages.length - 1];
  if (lng.toLowerCase() === 'cimode') return true;

  var loadNotPending = function loadNotPending(l, n) {
    var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
    return loadState === -1 || loadState === 2;
  };

  if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
  if (i18n.hasResourceBundle(lng, ns)) return true;
  if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
  return false;
}

function hasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!i18n.languages || !i18n.languages.length) {
    warnOnce('i18n.languages were undefined or empty', i18n.languages);
    return true;
  }

  var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;

  if (!isNewerI18next) {
    return oldI18nextHasLoadedNamespace(ns, i18n, options);
  }

  return i18n.hasLoadedNamespace(ns, {
    precheck: function precheck(i18nInstance, loadNotPending) {
      if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
    }
  });
}

function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var usePrevious = function usePrevious(value, ignore) {
  var ref = React.useRef();
  React.useEffect(function () {
    ref.current = ignore ? ref.current : value;
  }, [value, ignore]);
  return ref.current;
};

function useTranslation(ns) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var i18nFromProps = props.i18n;

  var _ref = React.useContext(I18nContext) || {},
      i18nFromContext = _ref.i18n,
      defaultNSFromContext = _ref.defaultNS;

  var i18n = i18nFromProps || i18nFromContext || getI18n();
  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new ReportNamespaces();

  if (!i18n) {
    warnOnce('You will need to pass in an i18next instance by using initReactI18next');

    var notReadyT = function notReadyT(k) {
      return Array.isArray(k) ? k[k.length - 1] : k;
    };

    var retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }

  if (i18n.options.react && i18n.options.react.wait !== undefined) warnOnce('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');

  var i18nOptions = _objectSpread$1(_objectSpread$1(_objectSpread$1({}, getDefaults()), i18n.options.react), props);

  var useSuspense = i18nOptions.useSuspense,
      keyPrefix = i18nOptions.keyPrefix;
  var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
  var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function (n) {
    return hasLoadedNamespace(n, i18n, i18nOptions);
  });

  function getT() {
    return i18n.getFixedT(null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
  }

  var _useState = React.useState(getT),
      _useState2 = _slicedToArray(_useState, 2),
      t = _useState2[0],
      setT = _useState2[1];

  var joinedNS = namespaces.join();
  var previousJoinedNS = usePrevious(joinedNS);
  var isMounted = React.useRef(true);
  React.useEffect(function () {
    var bindI18n = i18nOptions.bindI18n,
        bindI18nStore = i18nOptions.bindI18nStore;
    isMounted.current = true;

    if (!ready && !useSuspense) {
      loadNamespaces(i18n, namespaces, function () {
        if (isMounted.current) setT(getT);
      });
    }

    if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) {
      setT(getT);
    }

    function boundReset() {
      if (isMounted.current) setT(getT);
    }

    if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
    return function () {
      isMounted.current = false;
      if (bindI18n && i18n) bindI18n.split(' ').forEach(function (e) {
        return i18n.off(e, boundReset);
      });
      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function (e) {
        return i18n.store.off(e, boundReset);
      });
    };
  }, [i18n, joinedNS]);
  var isInitial = React.useRef(true);
  React.useEffect(function () {
    if (isMounted.current && !isInitial.current) {
      setT(getT);
    }

    isInitial.current = false;
  }, [i18n, keyPrefix]);
  var ret = [t, i18n, ready];
  ret.t = t;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready) return ret;
  if (!ready && !useSuspense) return ret;
  throw new Promise(function (resolve) {
    loadNamespaces(i18n, namespaces, function () {
      resolve();
    });
  });
}

function I18nextProvider(_ref) {
  var i18n = _ref.i18n,
      defaultNS = _ref.defaultNS,
      children = _ref.children;
  var value = React.useMemo(function () {
    return {
      i18n: i18n,
      defaultNS: defaultNS
    };
  }, [i18n, defaultNS]);
  return React.createElement(I18nContext.Provider, {
    value: value
  }, children);
}

var isNotVerified = function (user, status) {
    var verifyStatus = user.verificationStates.find(function (verification) { return verification.status === status; });
    return (verifyStatus === null || verifyStatus === void 0 ? void 0 : verifyStatus.value) === false;
};
/* A React hook that provides helper functions to create a login page.
 */
var useLogin = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.onSuccess, onSuccess = _c === void 0 ? function () { return false; } : _c, _d = _b.onError, onError = _d === void 0 ? function () { return false; } : _d;
    var securityConfig = useSecurityConfig();
    var setCredentials = useSetCredentials();
    var router = useRouter();
    var errorFromUrl = queryString.parse(router.search).error;
    var _e = React.useState(''), email = _e[0], setEmail = _e[1];
    var _f = React.useState(''), password = _f[0], setPassword = _f[1];
    var _g = React.useState(errorFromUrl || null), loginError = _g[0], setLoginError = _g[1];
    var _h = React.useState(null), error = _h[0], setError = _h[1];
    var _j = React.useState(false), logingInWithGoogle = _j[0], setLogingInWithGoogle = _j[1];
    var mustCheckApplicationPermission = Boolean(securityConfig.application);
    var _k = React.useState(false), logingInWithEmailAndPassword = _k[0], setLogingInWithEmailAndPassword = _k[1];
    var handleLoginWithGoogle = React.useCallback(function () {
        setLogingInWithGoogle(true);
        loginWithGoogle(securityConfig.redirectUri);
    }, [setLogingInWithGoogle]);
    var handleLoginWithEmailAndPassword = React.useCallback(function (_a) {
        var email = _a.email, password = _a.password;
        setLogingInWithEmailAndPassword(true);
        loginWithEmailAndPassword({
            username: email,
            password: password,
        })
            .then(function (result) {
            var user = result.user, token = result.token, refreshToken = result.refreshToken, isTrustedDevice = result.isTrustedDevice;
            onSuccess && onSuccess(result);
            if (isNotVerified(user, 'PHONE_VERIFIED')) {
                setCredentials({ token: token }, 'local');
                return router.push(securityConfig.phoneVerificationPath);
            }
            if (isNotVerified(user, 'EMAIL_VERIFIED')) {
                setCredentials({ token: token }, 'local');
                return router.push(securityConfig.emailVerificationPath);
            }
            if (!mustCheckApplicationPermission ||
                hasAccessToTheApplication(securityConfig.application, user) ||
                isTrustedDevice) {
                setCredentials({ authentication: user, token: token, refreshToken: refreshToken }, 'local');
                router.push(securityConfig.successPath);
            }
            else {
                setLoginError('no_application_permission');
            }
        })
            .catch(function (error) {
            var _a, _b, _c;
            setLoginError((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message);
            setError((_c = error.response) === null || _c === void 0 ? void 0 : _c.data);
            onError && onError(error);
        })
            .finally(function () {
            setLogingInWithEmailAndPassword(false);
        });
    }, [setLogingInWithEmailAndPassword, setCredentials, setLoginError, setError, securityConfig.successPath]);
    var handleEmailChange = React.useCallback(function (event) {
        setEmail(event.target.value);
    }, [setEmail]);
    var handlePasswordChange = React.useCallback(function (event) {
        setPassword(event.target.value);
    }, [setPassword]);
    return {
        handleLoginWithGoogle: handleLoginWithGoogle,
        handleLoginWithEmailAndPassword: handleLoginWithEmailAndPassword,
        loginError: loginError,
        error: error,
        logingInWithGoogle: logingInWithGoogle,
        logingInWithEmailAndPassword: logingInWithEmailAndPassword,
        handlePasswordChange: handlePasswordChange,
        handleEmailChange: handleEmailChange,
        email: email,
        password: password,
    };
};

function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? Object(arguments[r]) : {},
      o = Object.keys(t);
    "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), o.forEach(function (r) {
      _defineProperty(e, r, t[r]);
    });
  }
  return e;
}

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}

function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}

function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}

var consoleLogger = {
  type: 'logger',
  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    if (console && console[type]) console[type].apply(console, args);
  }
};

var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Logger);

    this.init(concreteLogger, options);
  }

  _createClass(Logger, [{
    key: "init",
    value: function init(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.prefix = options.prefix || 'i18next:';
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.forward(args, 'log', '', true);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.forward(args, 'warn', '', true);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.forward(args, 'error', '');
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create(moduleName) {
      return new Logger(this.logger, _objectSpread({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }, this.options));
    }
  }]);

  return Logger;
}();

var baseLogger = new Logger();

var EventEmitter = function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    this.observers = {};
  }

  _createClass(EventEmitter, [{
    key: "on",
    value: function on(events, listener) {
      var _this = this;

      events.split(' ').forEach(function (event) {
        _this.observers[event] = _this.observers[event] || [];

        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      if (!this.observers[event]) return;

      if (!listener) {
        delete this.observers[event];
        return;
      }

      this.observers[event] = this.observers[event].filter(function (l) {
        return l !== listener;
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function (observer) {
          observer.apply(void 0, args);
        });
      }

      if (this.observers['*']) {
        var _cloned = [].concat(this.observers['*']);

        _cloned.forEach(function (observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);

  return EventEmitter;
}();

function defer() {
  var res;
  var rej;
  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  return '' + object;
}
function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');

  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();

    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
  var value = getPath(data, key);

  if (value !== undefined) {
    return value;
  }

  return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
  for (var prop in source) {
    if (prop !== '__proto__' && prop !== 'constructor') {
      if (prop in target) {
        if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }

  return target;
}
function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
function escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}
var isIE10 = typeof window !== 'undefined' && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;

var ResourceStore = function (_EventEmitter) {
  _inherits(ResourceStore, _EventEmitter);

  function ResourceStore(data) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };

    _classCallCheck(this, ResourceStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ResourceStore).call(this));

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    _this.data = data || {};
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    return _this;
  }

  _createClass(ResourceStore, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index = this.options.ns.indexOf(ns);

      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var path = [lng, ns];
      if (key && typeof key !== 'string') path = path.concat(key);
      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
      }

      return getPath(this.data, path);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        silent: false
      };
      var keySeparator = this.options.keySeparator;
      if (keySeparator === undefined) keySeparator = '.';
      var path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        value = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      setPath(this.data, path, value);
      if (!options.silent) this.emit('added', lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        silent: false
      };

      for (var m in resources) {
        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }

      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
        silent: false
      };
      var path = [lng, ns];

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        deep = resources;
        resources = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      var pack = getPath(this.data, path) || {};

      if (deep) {
        deepExtend(pack, resources, overwrite);
      } else {
        pack = _objectSpread({}, pack, resources);
      }

      setPath(this.data, path, pack);
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }

      this.removeNamespaces(ns);
      this.emit('removed', lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== undefined;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS;
      if (this.options.compatibilityAPI === 'v1') return _objectSpread({}, {}, this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);

  return ResourceStore;
}(EventEmitter);

var postProcessor = {
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};

var checkedLoadedFor = {};

var Translator = function (_EventEmitter) {
  _inherits(Translator, _EventEmitter);

  function Translator(services) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Translator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Translator).call(this));

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, _assertThisInitialized(_this));
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    _this.logger = baseLogger.create('translator');
    return _this;
  }

  _createClass(Translator, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng) this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== undefined;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
      if (nsSeparator === undefined) nsSeparator = ':';
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS;

      if (nsSeparator && key.indexOf(nsSeparator) > -1) {
        var m = key.match(this.interpolator.nestingRegexp);

        if (m && m.length > 0) {
          return {
            key: key,
            namespaces: namespaces
          };
        }

        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }

      if (typeof namespaces === 'string') namespaces = [namespaces];
      return {
        key: key,
        namespaces: namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate(keys, options, lastKey) {
      var _this2 = this;

      if (_typeof(options) !== 'object' && this.options.overloadTranslationOptionHandler) {
        options = this.options.overloadTranslationOptionHandler(arguments);
      }

      if (!options) options = {};
      if (keys === undefined || keys === null) return '';
      if (!Array.isArray(keys)) keys = [String(keys)];
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
          key = _this$extractFromKey.key,
          namespaces = _this$extractFromKey.namespaces;

      var namespace = namespaces[namespaces.length - 1];
      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;

      if (lng && lng.toLowerCase() === 'cimode') {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;
          return namespace + nsSeparator + key;
        }

        return key;
      }

      var resolved = this.resolve(keys, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';

      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
        if (!options.returnObjects && !this.options.returnObjects) {
          this.logger.warn('accessing an object - but returnObjects options is not enabled!');
          return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, options) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
        }

        if (keySeparator) {
          var resTypeIsArray = resType === '[object Array]';
          var copy = resTypeIsArray ? [] : {};
          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;

          for (var m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
              copy[m] = this.translate(deepKey, _objectSpread({}, options, {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy[m] === deepKey) copy[m] = res[m];
            }
          }

          res = copy;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options, lastKey);
      } else {
        var usedDefault = false;
        var usedKey = false;
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var hasDefaultValue = Translator.hasDefaultValue(options);
        var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count) : '';
        var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;

        if (!this.isValidLookup(res) && hasDefaultValue) {
          usedDefault = true;
          res = defaultValue;
        }

        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        }

        var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;

        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);

          if (keySeparator) {
            var fk = this.resolve(key, _objectSpread({}, options, {
              keySeparator: false
            }));
            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
          }

          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);

          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
            for (var i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === 'all') {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }

          var send = function send(l, k, fallbackValue) {
            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l, namespace, k, updateMissing ? fallbackValue : res, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l, namespace, k, updateMissing ? fallbackValue : res, updateMissing, options);
            }

            _this2.emit('missingKey', l, namespace, k, res);
          };

          if (this.options.saveMissing) {
            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function (language) {
                _this2.pluralResolver.getSuffixes(language).forEach(function (suffix) {
                  send([language], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                });
              });
            } else {
              send(lngs, key, defaultValue);
            }
          }
        }

        res = this.extendTranslation(res, keys, options, resolved, lastKey);
        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
        if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
      }

      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved, lastKey) {
      var _this3 = this;

      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, options, resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved: resolved
        });
      } else if (!options.skipInterpolation) {
        if (options.interpolation) this.interpolator.init(_objectSpread({}, options, {
          interpolation: _objectSpread({}, this.options.interpolation, options.interpolation)
        }));
        var skipOnVariables = options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
        var nestBef;

        if (skipOnVariables) {
          var nb = res.match(this.interpolator.nestingRegexp);
          nestBef = nb && nb.length;
        }

        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = _objectSpread({}, this.options.interpolation.defaultVariables, data);
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options);

        if (skipOnVariables) {
          var na = res.match(this.interpolator.nestingRegexp);
          var nestAft = na && na.length;
          if (nestBef < nestAft) options.nest = false;
        }

        if (options.nest !== false) res = this.interpolator.nest(res, function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          if (lastKey && lastKey[0] === args[0] && !options.context) {
            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));

            return null;
          }

          return _this3.translate.apply(_this3, args.concat([key]));
        }, options);
        if (options.interpolation) this.interpolator.reset();
      }

      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread({
          i18nResolved: resolved
        }, options) : options, this);
      }

      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this4 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var found;
      var usedKey;
      var exactUsedKey;
      var usedLng;
      var usedNS;
      if (typeof keys === 'string') keys = [keys];
      keys.forEach(function (k) {
        if (_this4.isValidLookup(found)) return;

        var extracted = _this4.extractFromKey(k, options);

        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function (ns) {
          if (_this4.isValidLookup(found)) return;
          usedNS = ns;

          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;

            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
          }

          codes.forEach(function (code) {
            if (_this4.isValidLookup(found)) return;
            usedLng = code;
            var finalKey = key;
            var finalKeys = [finalKey];

            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count);
              if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);
              if (needsContextHandling) finalKeys.push(finalKey += "".concat(_this4.options.contextSeparator).concat(options.context));
              if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
            }

            var possibleKey;

            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey: usedKey,
        exactUsedKey: exactUsedKey,
        usedLng: usedLng,
        usedNS: usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }], [{
    key: "hasDefaultValue",
    value: function hasDefaultValue(options) {
      var prefix = 'defaultValue';

      for (var option in options) {
        if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
          return true;
        }
      }

      return false;
    }
  }]);

  return Translator;
}(EventEmitter);

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil = function () {
  function LanguageUtil(options) {
    _classCallCheck(this, LanguageUtil);

    this.options = options;
    this.whitelist = this.options.supportedLngs || false;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create('languageUtils');
  }

  _createClass(LanguageUtil, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return null;
      var p = code.split('-');
      if (p.length === 2) return null;
      p.pop();
      if (p[p.length - 1].toLowerCase() === 'x') return null;
      return this.formatLanguageCode(p.join('-'));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return code;
      var p = code.split('-');
      return this.formatLanguageCode(p[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
        var p = code.split('-');

        if (this.options.lowerCaseLng) {
          p = p.map(function (part) {
            return part.toLowerCase();
          });
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase();
          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
        }

        return p.join('-');
      }

      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isWhitelisted",
    value: function isWhitelisted(code) {
      this.logger.deprecate('languageUtils.isWhitelisted', 'function "isWhitelisted" will be renamed to "isSupportedCode" in the next major - please make sure to rename it\'s usage asap.');
      return this.isSupportedCode(code);
    }
  }, {
    key: "isSupportedCode",
    value: function isSupportedCode(code) {
      if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
        code = this.getLanguagePartFromCode(code);
      }

      return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function getBestMatchFromCodes(codes) {
      var _this = this;

      if (!codes) return null;
      var found;
      codes.forEach(function (code) {
        if (found) return;

        var cleanedLng = _this.formatLanguageCode(code);

        if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
      });

      if (!found && this.options.supportedLngs) {
        codes.forEach(function (code) {
          if (found) return;

          var lngOnly = _this.getLanguagePartFromCode(code);

          if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
          found = _this.options.supportedLngs.find(function (supportedLng) {
            if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
          });
        });
      }

      if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
      return found;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
      if (!code) return fallbacks["default"] || [];
      var found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
      if (!found) found = fallbacks["default"];
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this2 = this;

      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];

      var addCode = function addCode(c) {
        if (!c) return;

        if (_this2.isSupportedCode(c)) {
          codes.push(c);
        } else {
          _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
        }
      };

      if (typeof code === 'string' && code.indexOf('-') > -1) {
        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === 'string') {
        addCode(this.formatLanguageCode(code));
      }

      fallbackCodes.forEach(function (fc) {
        if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);

  return LanguageUtil;
}();

var sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'tl', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'kk', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he', 'iw'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');
    this.rules = createRules();
  }

  _createClass(PluralResolver, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var rule = this.getRule(code);
      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      return this.getSuffixes(code).map(function (suffix) {
        return key + suffix;
      });
    }
  }, {
    key: "getSuffixes",
    value: function getSuffixes(code) {
      var _this = this;

      var rule = this.getRule(code);

      if (!rule) {
        return [];
      }

      return rule.numbers.map(function (number) {
        return _this.getSuffix(code, number);
      });
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var _this2 = this;

      var rule = this.getRule(code);

      if (rule) {
        var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        var suffix = rule.numbers[idx];

        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
          if (suffix === 2) {
            suffix = 'plural';
          } else if (suffix === 1) {
            suffix = '';
          }
        }

        var returnSuffix = function returnSuffix() {
          return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
        };

        if (this.options.compatibilityJSON === 'v1') {
          if (suffix === 1) return '';
          if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
          return returnSuffix();
        } else if (this.options.compatibilityJSON === 'v2') {
          return returnSuffix();
        } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
          return returnSuffix();
        }

        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
      }

      this.logger.warn("no plural rule found for: ".concat(code));
      return '';
    }
  }]);

  return PluralResolver;
}();

var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Interpolator);

    this.logger = baseLogger.create('interpolator');
    this.options = options;

    this.format = options.interpolation && options.interpolation.format || function (value) {
      return value;
    };

    this.init(options);
  }

  _createClass(Interpolator, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== undefined ? iOpts.escape : escape;
      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
      this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
      this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options) this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, 'g');
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data, lng, options) {
      var _this = this;

      var match;
      var value;
      var replaces;
      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};

      function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
      }

      var handleFormat = function handleFormat(key) {
        if (key.indexOf(_this.formatSeparator) < 0) {
          var path = getPathWithDefaults(data, defaultData, key);
          return _this.alwaysFormat ? _this.format(path, undefined, lng) : path;
        }

        var p = key.split(_this.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this.formatSeparator).trim();
        return _this.format(getPathWithDefaults(data, defaultData, k), f, lng, options);
      };

      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
      var todos = [{
        regex: this.regexpUnescape,
        safeValue: function safeValue(val) {
          return regexSafe(val);
        }
      }, {
        regex: this.regexp,
        safeValue: function safeValue(val) {
          return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
        }
      }];
      todos.forEach(function (todo) {
        replaces = 0;

        while (match = todo.regex.exec(str)) {
          value = handleFormat(match[1].trim());

          if (value === undefined) {
            if (typeof missingInterpolationHandler === 'function') {
              var temp = missingInterpolationHandler(str, match, options);
              value = typeof temp === 'string' ? temp : '';
            } else if (skipOnVariables) {
              value = match[0];
              continue;
            } else {
              _this.logger.warn("missed to pass in variable ".concat(match[1], " for interpolating ").concat(str));

              value = '';
            }
          } else if (typeof value !== 'string' && !_this.useRawValueToEscape) {
            value = makeString(value);
          }

          str = str.replace(match[0], todo.safeValue(value));
          todo.regex.lastIndex = 0;
          replaces++;

          if (replaces >= _this.maxReplaces) {
            break;
          }
        }
      });
      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var _this2 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var match;
      var value;

      var clonedOptions = _objectSpread({}, options);

      clonedOptions.applyPostProcessor = false;
      delete clonedOptions.defaultValue;

      function handleHasOptions(key, inheritedOptions) {
        var sep = this.nestingOptionsSeparator;
        if (key.indexOf(sep) < 0) return key;
        var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
        var optionsString = "{".concat(c[1]);
        key = c[0];
        optionsString = this.interpolate(optionsString, clonedOptions);
        optionsString = optionsString.replace(/'/g, '"');

        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = _objectSpread({}, inheritedOptions, clonedOptions);
        } catch (e) {
          this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
          return "".concat(key).concat(sep).concat(optionsString);
        }

        delete clonedOptions.defaultValue;
        return key;
      }

      while (match = this.nestingRegexp.exec(str)) {
        var formatters = [];
        var doReduce = false;

        if (match[0].includes(this.formatSeparator) && !/{.*}/.test(match[1])) {
          var r = match[1].split(this.formatSeparator).map(function (elem) {
            return elem.trim();
          });
          match[1] = r.shift();
          formatters = r;
          doReduce = true;
        }

        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
        if (value && match[0] === str && typeof value !== 'string') return value;
        if (typeof value !== 'string') value = makeString(value);

        if (!value) {
          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
          value = '';
        }

        if (doReduce) {
          value = formatters.reduce(function (v, f) {
            return _this2.format(v, f, options.lng, options);
          }, value.trim());
        }

        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }

      return str;
    }
  }]);

  return Interpolator;
}();

function remove(arr, what) {
  var found = arr.indexOf(what);

  while (found !== -1) {
    arr.splice(found, 1);
    found = arr.indexOf(what);
  }
}

var Connector = function (_EventEmitter) {
  _inherits(Connector, _EventEmitter);

  function Connector(backend, store, services) {
    var _this;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, Connector);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Connector).call(this));

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = baseLogger.create('backendConnector');
    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }

    return _this;
  }

  _createClass(Connector, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;

      var toLoad = [];
      var pending = [];
      var toLoadLanguages = [];
      var toLoadNamespaces = [];
      languages.forEach(function (lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function (ns) {
          var name = "".concat(lng, "|").concat(ns);

          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2;
          } else if (_this2.state[name] < 0) ; else if (_this2.state[name] === 1) {
            if (pending.indexOf(name) < 0) pending.push(name);
          } else {
            _this2.state[name] = 1;
            hasAllNamespaces = false;
            if (pending.indexOf(name) < 0) pending.push(name);
            if (toLoad.indexOf(name) < 0) toLoad.push(name);
            if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
          }
        });
        if (!hasAllNamespaces) toLoadLanguages.push(lng);
      });

      if (toLoad.length || pending.length) {
        this.queue.push({
          pending: pending,
          loaded: {},
          errors: [],
          callback: callback
        });
      }

      return {
        toLoad: toLoad,
        pending: pending,
        toLoadLanguages: toLoadLanguages,
        toLoadNamespaces: toLoadNamespaces
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data) {
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      if (err) this.emit('failedLoading', lng, ns, err);

      if (data) {
        this.store.addResourceBundle(lng, ns, data);
      }

      this.state[name] = err ? -1 : 2;
      var loaded = {};
      this.queue.forEach(function (q) {
        pushPath(q.loaded, [lng], ns);
        remove(q.pending, name);
        if (err) q.errors.push(err);

        if (q.pending.length === 0 && !q.done) {
          Object.keys(q.loaded).forEach(function (l) {
            if (!loaded[l]) loaded[l] = [];

            if (q.loaded[l].length) {
              q.loaded[l].forEach(function (ns) {
                if (loaded[l].indexOf(ns) < 0) loaded[l].push(ns);
              });
            }
          });
          q.done = true;

          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      });
      this.emit('loaded', loaded);
      this.queue = this.queue.filter(function (q) {
        return !q.done;
      });
    }
  }, {
    key: "read",
    value: function read(lng, ns, fcName) {
      var _this3 = this;

      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 350;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      if (!lng.length) return callback(null, {});
      return this.backend[fcName](lng, ns, function (err, data) {
        if (err && data && tried < 5) {
          setTimeout(function () {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }

        callback(err, data);
      });
    }
  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;

      if (!this.backend) {
        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
        return callback && callback();
      }

      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === 'string') namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);

      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback();
        return null;
      }

      toLoad.toLoad.forEach(function (name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;

      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      this.read(lng, ns, 'read', undefined, undefined, function (err, data) {
        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);

        _this5.loaded(name, err, data);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        return;
      }

      if (key === undefined || key === null || key === '') return;

      if (this.backend && this.backend.create) {
        this.backend.create(languages, namespace, key, fallbackValue, null, _objectSpread({}, options, {
          isUpdate: isUpdate
        }));
      }

      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);

  return Connector;
}(EventEmitter);

function get() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    whitelist: false,
    nonExplicitWhitelist: false,
    supportedLngs: false,
    nonExplicitSupportedLngs: false,
    load: 'all',
    preload: false,
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    saveMissing: false,
    updateMissing: false,
    saveMissingTo: 'fallback',
    saveMissingPlurals: true,
    missingKeyHandler: false,
    missingInterpolationHandler: false,
    postProcess: false,
    postProcessPassResolved: false,
    returnNull: true,
    returnEmptyString: true,
    returnObjects: false,
    joinArrays: false,
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if (_typeof(args[1]) === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];

      if (_typeof(args[2]) === 'object' || _typeof(args[3]) === 'object') {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function (key) {
          ret[key] = options[key];
        });
      }

      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng, options) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      nestingOptionsSeparator: ',',
      maxReplaces: 1000,
      skipOnVariables: false
    }
  };
}
function transformOptions(options) {
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];

  if (options.whitelist) {
    if (options.whitelist && options.whitelist.indexOf('cimode') < 0) {
      options.whitelist = options.whitelist.concat(['cimode']);
    }

    options.supportedLngs = options.whitelist;
  }

  if (options.nonExplicitWhitelist) {
    options.nonExplicitSupportedLngs = options.nonExplicitWhitelist;
  }

  if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) {
    options.supportedLngs = options.supportedLngs.concat(['cimode']);
  }

  return options;
}

function noop() {}

var I18n = function (_EventEmitter) {
  _inherits(I18n, _EventEmitter);

  function I18n() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;

    _classCallCheck(this, I18n);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(I18n).call(this));

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized(_this));
    }

    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = baseLogger;
    _this.modules = {
      external: []
    };

    if (callback && !_this.isInitialized && !options.isClone) {
      if (!_this.options.initImmediate) {
        _this.init(options, callback);

        return _possibleConstructorReturn(_this, _assertThisInitialized(_this));
      }

      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }

    return _this;
  }

  _createClass(I18n, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      if (options.whitelist && !options.supportedLngs) {
        this.logger.deprecate('whitelist', 'option "whitelist" will be renamed to "supportedLngs" in the next major - please make sure to rename this option asap.');
      }

      if (options.nonExplicitWhitelist && !options.nonExplicitSupportedLngs) {
        this.logger.deprecate('whitelist', 'options "nonExplicitWhitelist" will be renamed to "nonExplicitSupportedLngs" in the next major - please make sure to rename this option asap.');
      }

      this.options = _objectSpread({}, get(), this.options, transformOptions(options));
      this.format = this.options.interpolation.format;
      if (!callback) callback = noop;

      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === 'function') return new ClassOrObject();
        return ClassOrObject;
      }

      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }

        var lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var s = this.services;
        s.logger = baseLogger;
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });
        s.interpolator = new Interpolator(this.options);
        s.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
        s.backendConnector.on('*', function (event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });

        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          s.languageDetector.init(s, this.options.detection, this.options);
        }

        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }

        this.translator = new Translator(this.services, this.options);
        this.translator.on('*', function (event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function (m) {
          if (m.init) m.init(_this2);
        });
      }

      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
      }

      if (!this.services.languageDetector && !this.options.lng) {
        this.logger.warn('init: no languageDetector is used and no lng is defined');
      }

      var storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApi.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store;

          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
      storeApiChained.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store2;

          (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);

          return _this2;
        };
      });
      var deferred = defer();

      var load = function load() {
        var finish = function finish(err, t) {
          if (_this2.isInitialized) _this2.logger.warn('init: i18next is already initialized. You should call init just once!');
          _this2.isInitialized = true;
          if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);

          _this2.emit('initialized', _this2.options);

          deferred.resolve(t);
          callback(err, t);
        };

        if (_this2.languages && _this2.options.compatibilityAPI !== 'v1' && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));

        _this2.changeLanguage(_this2.options.lng, finish);
      };

      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }

      return deferred;
    }
  }, {
    key: "loadResources",
    value: function loadResources(language) {
      var _this3 = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
      var usedCallback = callback;
      var usedLng = typeof language === 'string' ? language : this.language;
      if (typeof language === 'function') usedCallback = language;

      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
        var toLoad = [];

        var append = function append(lng) {
          if (!lng) return;

          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);

          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };

        if (!usedLng) {
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function (l) {
            return append(l);
          });
        } else {
          append(usedLng);
        }

        if (this.options.preload) {
          this.options.preload.forEach(function (l) {
            return append(l);
          });
        }

        this.services.backendConnector.load(toLoad, this.options.ns, usedCallback);
      } else {
        usedCallback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = defer();
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = noop;
      this.services.backendConnector.reload(lngs, ns, function (err) {
        deferred.resolve();
        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use(module) {
      if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
      if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');

      if (module.type === 'backend') {
        this.modules.backend = module;
      }

      if (module.type === 'logger' || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }

      if (module.type === 'languageDetector') {
        this.modules.languageDetector = module;
      }

      if (module.type === 'i18nFormat') {
        this.modules.i18nFormat = module;
      }

      if (module.type === 'postProcessor') {
        postProcessor.addPostProcessor(module);
      }

      if (module.type === '3rdParty') {
        this.modules.external.push(module);
      }

      return this;
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;

      this.isLanguageChangingTo = lng;
      var deferred = defer();
      this.emit('languageChanging', lng);

      var done = function done(err, l) {
        if (l) {
          _this4.language = l;
          _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);

          _this4.translator.changeLanguage(l);

          _this4.isLanguageChangingTo = undefined;

          _this4.emit('languageChanged', l);

          _this4.logger.log('languageChanged', l);
        } else {
          _this4.isLanguageChangingTo = undefined;
        }

        deferred.resolve(function () {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback) callback(err, function () {
          return _this4.t.apply(_this4, arguments);
        });
      };

      var setLng = function setLng(lngs) {
        var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);

        if (l) {
          if (!_this4.language) {
            _this4.language = l;
            _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
          }

          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
          if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
        }

        _this4.loadResources(l, function (err) {
          done(err, l);
        });
      };

      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        this.services.languageDetector.detect(setLng);
      } else {
        setLng(lng);
      }

      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns) {
      var _this5 = this;

      var fixedT = function fixedT(key, opts) {
        var options;

        if (_typeof(opts) !== 'object') {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }

          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options = _objectSpread({}, opts);
        }

        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        return _this5.t(key, options);
      };

      if (typeof lng === 'string') {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }

      fixedT.ns = ns;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t() {
      var _this$translator;

      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;

      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function hasLoadedNamespace(ns) {
      var _this6 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this.isInitialized) {
        this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
        return false;
      }

      if (!this.languages || !this.languages.length) {
        this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
        return false;
      }

      var lng = this.languages[0];
      var fallbackLng = this.options ? this.options.fallbackLng : false;
      var lastLng = this.languages[this.languages.length - 1];
      if (lng.toLowerCase() === 'cimode') return true;

      var loadNotPending = function loadNotPending(l, n) {
        var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];

        return loadState === -1 || loadState === 2;
      };

      if (options.precheck) {
        var preResult = options.precheck(this, loadNotPending);
        if (preResult !== undefined) return preResult;
      }

      if (this.hasResourceBundle(lng, ns)) return true;
      if (!this.services.backendConnector.backend) return true;
      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
      return false;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces(ns, callback) {
      var _this7 = this;

      var deferred = defer();

      if (!this.options.ns) {
        callback && callback();
        return Promise.resolve();
      }

      if (typeof ns === 'string') ns = [ns];
      ns.forEach(function (n) {
        if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
      });
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = defer();
      if (typeof lngs === 'string') lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function (lng) {
        return preloaded.indexOf(lng) < 0;
      });

      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }

      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
      if (!lng) return 'rtl';
      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];
      return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
    }
  }, {
    key: "createInstance",
    value: function createInstance() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      return new I18n(options, callback);
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this8 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

      var mergedOptions = _objectSpread({}, this.options, options, {
        isClone: true
      });

      var clone = new I18n(mergedOptions);
      var membersToCopy = ['store', 'services', 'language'];
      membersToCopy.forEach(function (m) {
        clone[m] = _this8[m];
      });
      clone.services = _objectSpread({}, this.services);
      clone.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      clone.translator = new Translator(clone.services, clone.options);
      clone.translator.on('*', function (event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }

        clone.emit.apply(clone, [event].concat(args));
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = clone.options;
      clone.translator.backendConnector.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      return clone;
    }
  }]);

  return I18n;
}(EventEmitter);

var i18next = new I18n();

var sign_out$1 = "Abmelden";
var sign_in$1 = "Anmelden";
var sign_in_with_google$1 = "Mit Google anmelden";
var insufficient_permission$1 = "Sie sind leider nicht berechtigt die Applikation zu benutzen.<br /> <small>Bitte kontaktieren Sie Dental21.</small>";
var no_application_permission$1 = "Sie sind leider nicht berechtig die Applikation zu benutzen.";
var session_expired$1 = "Deine Session ist abgelaufen. Bitte einloggen Sie sich erneut an.";
var or$1 = "Oder mit E–Mail Adresse einloggen";
var email$1 = "E-Mail";
var password$1 = "Passwort";
var welcome$1 = "Willkommen zurück!";
var by$1 = "Von";
var deTranslations = {
	sign_out: sign_out$1,
	sign_in: sign_in$1,
	sign_in_with_google: sign_in_with_google$1,
	insufficient_permission: insufficient_permission$1,
	no_application_permission: no_application_permission$1,
	session_expired: session_expired$1,
	or: or$1,
	email: email$1,
	password: password$1,
	welcome: welcome$1,
	by: by$1
};

var sign_out = "Sign out";
var sign_in = "Login to your account";
var sign_in_with_google = "Login with Google";
var insufficient_permission = "You do not have sufficient permission to view this page. <br /> <small>Please contact your administrator for more details.</small>";
var no_application_permission = "You do not have sufficient permission to view this application.";
var session_expired = "Your session has expired. Please log in again.";
var or = "Or using your email address";
var email = "Email";
var password = "Password";
var welcome = "Welcome back!";
var by = "By";
var enTranslations = {
	sign_out: sign_out,
	sign_in: sign_in,
	sign_in_with_google: sign_in_with_google,
	insufficient_permission: insufficient_permission,
	no_application_permission: no_application_permission,
	session_expired: session_expired,
	or: or,
	email: email,
	password: password,
	welcome: welcome,
	by: by
};

exports.Application = void 0;
(function (Application) {
    Application["INSIGHT"] = "INSIGHT";
    Application["HADES"] = "HADES";
    Application["CALMASTER"] = "CALMASTER";
    Application["JARVIS"] = "JARVIS";
    Application["SHIFT_PLANNER"] = "SHIFT_PLANNER";
})(exports.Application || (exports.Application = {}));
exports.Language = void 0;
(function (Language) {
    Language["EN"] = "en";
    Language["DE"] = "de";
})(exports.Language || (exports.Language = {}));
exports.ResetAuthPartKind = void 0;
(function (ResetAuthPartKind) {
    ResetAuthPartKind["PASSWORD"] = "PASSWORD";
    ResetAuthPartKind["PHONE_NUMBER"] = "PHONE_NUMBER";
})(exports.ResetAuthPartKind || (exports.ResetAuthPartKind = {}));
exports.PermissionLevel = void 0;
(function (PermissionLevel) {
    PermissionLevel["TENANT_ADMIN"] = "TENANT_ADMIN";
    PermissionLevel["SUPER_ADMIN"] = "SUPER_ADMIN";
    PermissionLevel["SAME_CLINIC"] = "SAME_CLINIC";
    PermissionLevel["SAME_LEVEL"] = "SAME_LEVEL";
    PermissionLevel["OWN"] = "OWN";
})(exports.PermissionLevel || (exports.PermissionLevel = {}));
exports.PermissionAction = void 0;
(function (PermissionAction) {
    PermissionAction["READ"] = "READ";
    PermissionAction["WRITE"] = "WRITE";
    PermissionAction["READ_WRITE"] = "READ_WRITE";
})(exports.PermissionAction || (exports.PermissionAction = {}));
exports.PermissionResource = void 0;
(function (PermissionResource) {
    PermissionResource["ALL"] = "ALL";
    PermissionResource["CLINIC"] = "CLINIC";
    PermissionResource["PRACTITIONER"] = "PRACTITIONER";
    PermissionResource["REVENUE"] = "REVENUE";
    PermissionResource["APPOINTMENT"] = "APPOINTMENT";
    PermissionResource["COST_PLAN"] = "COST_PLAN";
    PermissionResource["WORK_SCHEDULE"] = "WORK_SCHEDULE";
    PermissionResource["TREATMENT"] = "TREATMENT";
    PermissionResource["TREATMENT_GROUP"] = "TREATMENT_GROUP";
    PermissionResource["PATIENT"] = "PATIENT";
    PermissionResource["ROOM"] = "ROOM";
    PermissionResource["DATA_ISSUE"] = "DATA_ISSUE";
    PermissionResource["STATISTIC"] = "STATISTIC";
    PermissionResource["USER"] = "USER";
    PermissionResource["ROLE"] = "ROLE";
    PermissionResource["TENANT"] = "TENANT";
    PermissionResource["NPS"] = "NPS";
    PermissionResource["ANAMNESIS"] = "ANAMNESIS";
    PermissionResource["ANAMNESIS_CODE"] = "ANAMNESIS_CODE";
    PermissionResource["PHONE_CALLS"] = "PHONE_CALLS";
    PermissionResource["PHONE_SETUP"] = "PHONE_SETUP";
    PermissionResource["TEXT_MESSAGES"] = "TEXT_MESSAGES";
    PermissionResource["GENERAL_TREATMENTS"] = "GENERAL_TREATMENTS";
    PermissionResource["MEDICAL_RECORDS"] = "MEDICAL_RECORDS";
    PermissionResource["CODE_2FA"] = "CODE_2FA";
    PermissionResource["TRACK_RECORDS"] = "TRACK_RECORDS";
    PermissionResource["TRACK_RECORDS_SUPERUSER"] = "TRACK_RECORDS_SUPERUSER";
})(exports.PermissionResource || (exports.PermissionResource = {}));

var i18nInstance = i18next.createInstance();
i18nInstance.init({
    resources: {
        en: { translation: enTranslations },
        de: { translation: deTranslations },
    },
    lng: 'de',
    fallbackLng: exports.Language.EN,
    interpolation: {
        escapeValue: false,
    },
});

function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}

var ArrowDownIcon = function (_a) {
    var className = _a.className;
    return (React__default["default"].createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
        React__default["default"].createElement("path", { fill: "#000", d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" })));
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$6 = ".Accordion-module_root__cCog2 .Accordion-module_summary__ORyIA {\n  cursor: pointer;\n  list-style: none;\n}\n.Accordion-module_root__cCog2 .Accordion-module_summary__ORyIA::-webkit-details-marker, .Accordion-module_root__cCog2 .Accordion-module_summary__ORyIA::marker {\n  display: none;\n}\n.Accordion-module_root__cCog2 .Accordion-module_summary__ORyIA:active, .Accordion-module_root__cCog2 .Accordion-module_summary__ORyIA:focus {\n  outline: none;\n}\n.Accordion-module_root__cCog2 .Accordion-module_arrowIcon__nLV2k {\n  font-size: 24px;\n  margin-left: 4px;\n  transition: 200ms ease transform;\n  will-change: transform;\n}\n.Accordion-module_root__cCog2.Accordion-module_open__rJyCm .Accordion-module_arrowIcon__nLV2k {\n  transform: rotate(180deg);\n}\n.Accordion-module_root__cCog2 .Accordion-module_title__-9-np {\n  line-height: 24px;\n  display: flex;\n  align-items: center;\n}";
var classes$6 = {"root":"Accordion-module_root__cCog2","summary":"Accordion-module_summary__ORyIA","arrowIcon":"Accordion-module_arrowIcon__nLV2k","open":"Accordion-module_open__rJyCm","title":"Accordion-module_title__-9-np"};
styleInject(css_248z$6);

var Accordion = function (_a) {
    var _b;
    var title = _a.title, className = _a.className, children = _a.children;
    var _c = React.useState(false), isOpen = _c[0], setIsOpen = _c[1];
    var handleToggle = function () { return setIsOpen(function (value) { return !value; }); };
    return (React__default["default"].createElement("details", { className: clsx(classes$6.root, className, (_b = {},
            _b[classes$6.open] = isOpen,
            _b)), open: isOpen, onToggle: handleToggle },
        React__default["default"].createElement("summary", { className: classes$6.summary },
            React__default["default"].createElement("div", { className: classes$6.title },
                title,
                React__default["default"].createElement(ArrowDownIcon, { className: classes$6.arrowIcon }))),
        React__default["default"].createElement("div", null, children)));
};

var css_248z$5 = ".Button-module_root__8RX49 {\n  padding: 16px;\n  border: none;\n  border-radius: 5px;\n  background-color: #fff;\n  font-size: 16px;\n  font-weight: bold;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-sizing: border-box;\n}\n.Button-module_root__8RX49.Button-module_primary__st6yY {\n  background-color: #6bc8bb;\n  color: #fff;\n}\n.Button-module_root__8RX49.Button-module_primary__st6yY:hover:not(:disabled) {\n  background-color: #5db6aa;\n}\n.Button-module_root__8RX49.Button-module_secondary__j-3rj {\n  background-color: #372d41;\n  color: #fff;\n}\n.Button-module_root__8RX49.Button-module_secondary__j-3rj:hover:not(:disabled) {\n  background-color: #32293c;\n}\n.Button-module_root__8RX49.Button-module_fullWidth__AHpSl {\n  width: 100%;\n}\n.Button-module_root__8RX49:disabled {\n  opacity: 0.6;\n  cursor: default;\n}\n\n.Button-module_iconWrapper__Pkl3f {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n.Button-module_iconWrapper__Pkl3f svg {\n  font-size: 20px;\n}\n.Button-module_iconWrapper__Pkl3f.Button-module_startIcon__pTA6B {\n  margin-right: 10px;\n}\n.Button-module_iconWrapper__Pkl3f.Button-module_endIcon__SYmHq {\n  margin-left: 10px;\n}";
var classes$5 = {"root":"Button-module_root__8RX49","primary":"Button-module_primary__st6yY","secondary":"Button-module_secondary__j-3rj","fullWidth":"Button-module_fullWidth__AHpSl","iconWrapper":"Button-module_iconWrapper__Pkl3f","startIcon":"Button-module_startIcon__pTA6B","endIcon":"Button-module_endIcon__SYmHq"};
styleInject(css_248z$5);

var Button = function (_a) {
    var _b;
    var color = _a.color, startIcon = _a.startIcon, endIcon = _a.endIcon, children = _a.children, className = _a.className, _c = _a.fullWidth, fullWidth = _c === void 0 ? false : _c, rest = __rest(_a, ["color", "startIcon", "endIcon", "children", "className", "fullWidth"]);
    return (React__default["default"].createElement("button", __assign({}, rest, { className: clsx(classes$5.root, className, (_b = {},
            _b[classes$5.secondary] = color === 'secondary',
            _b[classes$5.primary] = color === 'primary',
            _b[classes$5.fullWidth] = fullWidth,
            _b)) }),
        startIcon && React__default["default"].createElement("span", { className: clsx(classes$5.iconWrapper, classes$5.startIcon) }, startIcon),
        children,
        endIcon && React__default["default"].createElement("span", { className: clsx(classes$5.iconWrapper, classes$5.endIcon) }, endIcon)));
};

var EmailIcon = function (_a) {
    var className = _a.className;
    return (React__default["default"].createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
        React__default["default"].createElement("path", { fill: "#000", fillOpacity: "0.54", d: "M21.99 8c0-.72-.37-1.35-.94-1.7l-8.04-4.71c-.62-.37-1.4-.37-2.02 0L2.95 6.3C2.38 6.65 2 7.28 2 8v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2l-.01-10zm-11.05 4.34l-7.2-4.5 7.25-4.25c.62-.37 1.4-.37 2.02 0l7.25 4.25-7.2 4.5c-.65.4-1.47.4-2.12 0z" })));
};

var EyeIcon = function (_a) {
    var className = _a.className;
    return (React__default["default"].createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
        React__default["default"].createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12 5C7 5 2.73 8.11 1 12.5 2.73 16.89 7 20 12 20s9.27-3.11 11-7.5C21.27 8.11 17 5 12 5zm0 12.5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z", clipRule: "evenodd" })));
};

var GoogleLogo = function (_a) {
    var className = _a.className;
    return (React__default["default"].createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24" },
        React__default["default"].createElement("path", { fill: "#4285F4", d: "M-3.264 51.509c0-.79-.07-1.54-.19-2.27h-11.3v4.51h6.47c-.29 1.48-1.14 2.73-2.4 3.58v3h3.86c2.26-2.09 3.56-5.17 3.56-8.82z", transform: "translate(27.009 -39.239)" }),
        React__default["default"].createElement("path", { fill: "#34A853", d: "M-14.754 63.239c3.24 0 5.95-1.08 7.93-2.91l-3.86-3c-1.08.72-2.45 1.16-4.07 1.16-3.13 0-5.78-2.11-6.73-4.96h-3.98v3.09c1.97 3.92 6.02 6.62 10.71 6.62z", transform: "translate(27.009 -39.239)" }),
        React__default["default"].createElement("path", { fill: "#FBBC05", d: "M-21.484 53.529c-.25-.72-.38-1.49-.38-2.29s.14-1.57.38-2.29v-3.09h-3.98a11.86 11.86 0 000 10.76l3.98-3.09z", transform: "translate(27.009 -39.239)" }),
        React__default["default"].createElement("path", { fill: "#EA4335", d: "M-14.754 43.989c1.77 0 3.35.61 4.6 1.8l3.42-3.42c-2.07-1.94-4.78-3.13-8.02-3.13-4.69 0-8.74 2.7-10.71 6.62l3.98 3.09c.95-2.85 3.6-4.96 6.73-4.96z", transform: "translate(27.009 -39.239)" })));
};

var css_248z$4 = ".HelperText-module_root__2lGq9 {\n  font-size: 14px;\n}\n.HelperText-module_root__2lGq9.HelperText-module_colorError__1l-5q {\n  color: #f44336;\n}";
var classes$4 = {"root":"HelperText-module_root__2lGq9","colorError":"HelperText-module_colorError__1l-5q"};
styleInject(css_248z$4);

var HelperText = function (_a) {
    var _b;
    var _c = _a.color, color = _c === void 0 ? 'default' : _c, children = _a.children;
    return (React__default["default"].createElement("p", { className: clsx(classes$4.root, (_b = {},
            _b[classes$4.colorError] = color === 'error',
            _b)) }, children));
};

var HidePasswordIcon = function (_a) {
    var className = _a.className;
    return (React__default["default"].createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24" },
        React__default["default"].createElement("path", { fill: "currentColor", d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46A11.804 11.804 0 001 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" })));
};

var DropdownArrowIcon = function (_a) {
    var className = _a.className;
    return (React__default["default"].createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
        React__default["default"].createElement("path", { fill: "currentColor", d: "M7 10l5 5 5-5H7z" })));
};

var LanguageIcon = function (_a) {
    var className = _a.className;
    return (React__default["default"].createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
        React__default["default"].createElement("path", { fill: "currentColor", d: "M12 2.4c-5.293 0-9.6 4.308-9.6 9.6 0 5.293 4.307 9.6 9.6 9.6 5.292 0 9.6-4.308 9.6-9.6S17.292 2.4 12 2.4zM12 4c.314 0 .64.13 1.012.477.373.346.758.904 1.088 1.63.15.331.286.7.41 1.093H9.49c.125-.393.26-.762.41-1.092.331-.727.716-1.285 1.088-1.631C11.36 4.13 11.685 4 12 4zm-3.13.634a8.78 8.78 0 00-.426.813C8.2 5.98 7.994 6.57 7.819 7.2H5.605A7.995 7.995 0 018.87 4.634zm6.26 0A7.995 7.995 0 0118.395 7.2h-2.214c-.176-.63-.383-1.22-.625-1.753a8.781 8.781 0 00-.426-.813zM4.667 8.8h2.797a18.792 18.792 0 00-.245 2.4h-3.18a7.962 7.962 0 01.628-2.4zm4.424 0h5.818c.14.748.235 1.554.272 2.4H8.82a17.09 17.09 0 01.272-2.4zm7.445 0h2.797c.325.747.544 1.553.628 2.4h-3.18a18.784 18.784 0 00-.245-2.4zm-12.497 4h3.18c.032.836.116 1.638.245 2.4H4.667a7.962 7.962 0 01-.628-2.4zm4.78 0h6.362a17.1 17.1 0 01-.272 2.4H9.091a17.09 17.09 0 01-.272-2.4zm7.962 0h3.18a7.96 7.96 0 01-.628 2.4h-2.797c.129-.762.213-1.564.245-2.4zm-11.176 4h2.214c.176.63.382 1.22.625 1.753.13.289.276.556.426.813A7.995 7.995 0 015.605 16.8zm3.884 0h5.022c-.125.393-.26.762-.411 1.092-.33.727-.715 1.285-1.088 1.631-.372.347-.698.477-1.012.477-.315 0-.64-.13-1.013-.477-.372-.346-.757-.904-1.087-1.63-.15-.331-.286-.7-.411-1.093zm6.692 0h2.214a7.995 7.995 0 01-3.265 2.566c.15-.257.295-.524.426-.813.242-.533.45-1.123.625-1.753z" })));
};

var css_248z$3 = ".LanguagePicker-module_button__XcYH- {\n  width: auto;\n  background: transparent;\n  border: none;\n  padding: 12px;\n  cursor: pointer;\n  color: #372d41;\n}\n.LanguagePicker-module_button__XcYH-:active {\n  outline: none;\n}\n\n.LanguagePicker-module_icon__WEPx0 {\n  font-size: 24px;\n}\n\n.LanguagePicker-module_dropdownContainer__H4lSF {\n  background-color: #fff;\n  position: absolute;\n  right: 0;\n  box-shadow: 0px 16px 24px rgba(0, 0, 0, 0.14);\n  border-radius: 0 0 8px 8px;\n  width: auto;\n  margin-top: 44px;\n  margin-right: 8px;\n}\n\n.LanguagePicker-module_dropdownArrow__GLeiP {\n  font-size: 24px;\n}\n\n.LanguagePicker-module_menu__w1iSR {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  width: 170px;\n}\n\n.LanguagePicker-module_menuItem__dm2J1 {\n  padding: 12px;\n  font-size: 14px;\n  line-height: 20px;\n  letter-spacing: 0.25px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  color: rgba(0, 0, 0, 0.54);\n}\n.LanguagePicker-module_menuItem__dm2J1 .LanguagePicker-module_icon__WEPx0 {\n  margin-right: 12px;\n  font-size: 20px;\n}\n.LanguagePicker-module_menuItem__dm2J1:first-of-type:before {\n  content: \"\";\n  position: absolute;\n  border-bottom: 18px solid #fff;\n  border-top-color: inherit;\n  border-left: 13px solid transparent;\n  border-right: 13px solid transparent;\n  top: -10px;\n  right: 3px;\n}\n.LanguagePicker-module_menuItem__dm2J1:last-of-type {\n  border-radius: 0 0 8px 8px;\n}\n.LanguagePicker-module_menuItem__dm2J1.LanguagePicker-module_menuItemSelected__8gNJ6:first-of-type:before {\n  border-bottom-color: #d2eeea;\n}\n\n.LanguagePicker-module_menuItemSelected__8gNJ6 {\n  background-color: rgba(107, 200, 187, 0.3);\n  color: #372d41;\n}";
var classes$3 = {"button":"LanguagePicker-module_button__XcYH-","icon":"LanguagePicker-module_icon__WEPx0","dropdownContainer":"LanguagePicker-module_dropdownContainer__H4lSF","dropdownArrow":"LanguagePicker-module_dropdownArrow__GLeiP","menu":"LanguagePicker-module_menu__w1iSR","menuItem":"LanguagePicker-module_menuItem__dm2J1","menuItemSelected":"LanguagePicker-module_menuItemSelected__8gNJ6"};
styleInject(css_248z$3);

var languages = [
    {
        code: exports.Language.DE,
        label: 'Deutsch',
    },
    {
        code: exports.Language.EN,
        label: 'English',
    },
];
var LanguagePicker = function (_a) {
    var className = _a.className;
    var i18n = useTranslation().i18n;
    var _b = React.useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var dropdownRef = React.useRef(null);
    var isOpen = Boolean(anchorEl);
    var handleToggle = function (e) {
        setAnchorEl(anchorEl ? null : e.currentTarget);
    };
    var handleGlobalClick = React.useCallback(function (e) {
        var _a;
        // Close the dropdown if the click is outside of the dropdown container
        if (!((_a = dropdownRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
            setAnchorEl(null);
        }
    }, []);
    var createHandleLanguageClick = function (language) { return function () {
        i18n.changeLanguage(language);
    }; };
    var dropdownPosition = React.useMemo(function () {
        var _a, _b, _c, _d;
        if (!anchorEl)
            return;
        return {
            top: (_b = (_a = anchorEl === null || anchorEl === void 0 ? void 0 : anchorEl.getBoundingClientRect) === null || _a === void 0 ? void 0 : _a.call(anchorEl)) === null || _b === void 0 ? void 0 : _b.top,
            right: window.innerWidth - ((_d = (_c = anchorEl === null || anchorEl === void 0 ? void 0 : anchorEl.getBoundingClientRect) === null || _c === void 0 ? void 0 : _c.call(anchorEl)) === null || _d === void 0 ? void 0 : _d.right),
        };
    }, [anchorEl]);
    React.useEffect(function () {
        if (anchorEl) {
            document.addEventListener('click', handleGlobalClick);
            return function () { return document.removeEventListener('click', handleGlobalClick); };
        }
    }, [anchorEl, handleGlobalClick]);
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement("button", { className: clsx(classes$3.button, className), onClick: handleToggle },
            React__default["default"].createElement(LanguageIcon, { className: classes$3.icon }),
            " ",
            React__default["default"].createElement(DropdownArrowIcon, { className: classes$3.dropdownArrow })),
        isOpen && (React__default["default"].createElement("div", { className: classes$3.dropdownContainer, style: dropdownPosition, ref: dropdownRef },
            React__default["default"].createElement("ul", { className: classes$3.menu }, languages.map(function (language) {
                var _a;
                return (React__default["default"].createElement("li", { key: language.code, className: clsx(classes$3.menuItem, (_a = {},
                        _a[classes$3.menuItemSelected] = language.code === i18n.language,
                        _a)), onClick: createHandleLanguageClick(language.code) },
                    React__default["default"].createElement(LanguageIcon, { className: classes$3.icon }),
                    " ",
                    language.label));
            }))))));
};

var LogoWhite = function () {
    return (React__default["default"].createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "283", height: "51", fill: "none", viewBox: "0 0 283 51" },
        React__default["default"].createElement("g", { fill: "#fff", clipPath: "url(#clip0_15:261)" },
            React__default["default"].createElement("path", { d: "M249.162.69c7.792 0 13.2 4.653 13.2 11.74 0 5.088-2.974 9.125-8.981 12.12l-5.84 2.92c-2.164 1.14-4.744 2.979-4.744 5.303h19.584v6.205h-26.69v-5.23c0-6.113 5.139-10.117 8.759-11.901l6.062-3.033c3.084-1.515 4.653-3.68 4.653-6.438 0-3.515-2.328-5.788-6.007-5.788-4.058 0-6.383 3.083-6.277 7.682h-7.19C235.527 5.883 240.874.69 249.162.69zM282.18 6.051V1.095h-6.23v2.164c0 .551-.108 1.097-.318 1.606a4.209 4.209 0 01-2.27 2.272 4.19 4.19 0 01-1.605.32h-4.197v5.904H275.019v25.646h7.15V6.051h.011zM198.225.69a8.004 8.004 0 018.003 8.003v8.004h-8.003a8.005 8.005 0 110-16.007zM190.225 31.427a8 8 0 018-8.004h7.992v8.004a8.005 8.005 0 01-7.992 8 8.003 8.003 0 01-8-8zM220.958 39.427a8.004 8.004 0 01-8.004-8v-7.993h8.004a8 8 0 018.003 7.993 8.003 8.003 0 01-8.003 8zM228.961 8.693a8.003 8.003 0 01-8.003 8.004h-8.004V8.693A8.007 8.007 0 01220.958.69a8.002 8.002 0 018.003 8.003zM0 11.697h6.606v3.412c1.627-2.335 4.606-3.843 8.233-3.843 7.854 0 12.672 5.741 12.672 14.08 0 8.34-5.143 14.07-13.16 14.07-3.285 0-6.227-1.3-7.745-3.413V50.03H0V11.697zm20.905 13.65c0-5.037-2.92-8.34-7.3-8.34-4.496 0-7.419 3.285-7.419 8.34 0 5.054 2.92 8.339 7.42 8.339 4.376 0 7.299-3.303 7.299-8.34zM32.007 25.346c0-8.339 4.767-14.08 12.89-14.08 3.413 0 6.39 1.405 7.96 3.519v-3.088h6.66v27.295h-6.66V35.8c-1.299 2.157-4.441 3.617-7.85 3.617-8.233 0-13-5.73-13-14.07zm21.34 0c0-5.036-2.92-8.339-7.42-8.339-4.38 0-7.3 3.285-7.3 8.34 0 5.054 2.92 8.339 7.3 8.339 4.496 0 7.42-3.303 7.42-8.34zM76.96 3.467v8.23h7.583v5.58h-7.584v11.92c0 2.763 1.46 4.171 3.953 4.171h3.65V39h-4.38c-5.96 0-9.854-3.464-9.854-9.53V17.278h-5.39v-5.58h5.36v-8.23h6.661zM96.715 0v7.42H89.58V0h7.135zM89.85 11.697h6.66v27.295h-6.66V11.697zM128.831 29.894c-1.018 5.796-6.11 9.522-12.825 9.522-8.934 0-13.916-7.04-13.916-14.19 0-7.204 4.438-13.97 13.376-13.97 9.153 0 13.266 6.66 13.266 13.156 0 .924-.051 1.734-.105 2.278h-20.146c.485 4.38 3.303 7.2 7.525 7.2 3.413 0 5.635-1.405 6.336-4.014l6.489.018zm-20.19-7.58h13.431c-.27-3.467-2.653-6.066-6.606-6.066-3.737 0-6.12 1.949-6.825 6.066zM134.422 11.697h6.661v4.226c1.518-2.978 4.602-4.657 8.503-4.657 6.172 0 10.183 4.438 10.183 10.829v16.897h-6.664V23.504c0-3.738-2.274-6.336-5.686-6.336-3.738 0-6.336 2.92-6.336 6.934v14.894h-6.661V11.697zM175.911 3.467v8.23h7.58v5.58h-7.58v11.92c0 2.763 1.46 4.171 3.952 4.171h3.628V39h-4.379c-5.957 0-9.854-3.464-9.854-9.53V17.278h-5.391v-5.58h5.365v-8.23h6.679z" })),
        React__default["default"].createElement("defs", null,
            React__default["default"].createElement("clipPath", { id: "clip0_15:261" },
                React__default["default"].createElement("path", { fill: "#fff", d: "M0 0H282.18V50.04H0z" })))));
};

var MasterLogo = function (_a) {
    var className = _a.className;
    return (React__default["default"].createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "56", height: "24", fill: "none", viewBox: "0 0 56 24" },
        React__default["default"].createElement("g", { fill: "#6BC8BB", clipPath: "url(#clip0_675:4852)" },
            React__default["default"].createElement("path", { d: "M35.774 0c4.73 0 8.013 2.883 8.013 7.275 0 3.15-1.806 5.664-5.451 7.508l-3.547 1.81c-1.314.704-2.89 1.844-2.89 3.286h11.888v3.854h-16.19v-3.251c0-3.788 3.12-6.268 5.32-7.375l3.68-1.877c1.87-.939 2.823-2.28 2.823-3.989 0-2.18-1.412-3.586-3.645-3.586-2.463 0-3.875 1.91-3.81 4.76h-4.368C27.497 3.218 30.75 0 35.774 0zM55.814 3.32V.25h-3.78v1.342c0 .69-.268 1.35-.746 1.838a2.522 2.522 0 01-1.8.762h-2.549v3.657h4.437c.033 0 .065-.004.098-.005v15.887h4.339V3.32v.002zM4.857 0c1.289 0 2.524.522 3.435 1.452a5.01 5.01 0 011.423 3.506v4.958H4.857a4.808 4.808 0 01-3.434-1.452A5.01 5.01 0 010 4.958a5.01 5.01 0 011.423-3.506A4.808 4.808 0 014.857 0zM0 19.042a5.01 5.01 0 011.423-3.506 4.808 4.808 0 013.434-1.452h4.858v4.958a5.01 5.01 0 01-1.423 3.506A4.808 4.808 0 014.857 24a4.808 4.808 0 01-3.434-1.452A5.01 5.01 0 010 19.042zM18.655 24a4.808 4.808 0 01-3.435-1.452 5.01 5.01 0 01-1.423-3.506v-4.958h4.858c1.288 0 2.523.522 3.434 1.452a5.01 5.01 0 011.423 3.506 5.01 5.01 0 01-1.423 3.506A4.808 4.808 0 0118.655 24zM23.512 4.958a5.01 5.01 0 01-1.423 3.506 4.808 4.808 0 01-3.434 1.452h-4.858V4.958a5.01 5.01 0 011.423-3.506A4.808 4.808 0 0118.655 0c1.288 0 2.523.522 3.434 1.452a5.01 5.01 0 011.423 3.506z" })),
        React__default["default"].createElement("defs", null,
            React__default["default"].createElement("clipPath", { id: "clip0_675:4852" },
                React__default["default"].createElement("path", { fill: "#fff", d: "M0 0H55.814V24H0z" })))));
};

var PasswordIcon = function (_a) {
    var className = _a.className;
    return (React__default["default"].createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
        React__default["default"].createElement("path", { fill: "currentColor", d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H8.9V6zM15 16h-2v2c0 .55-.45 1-1 1s-1-.45-1-1v-2H9c-.55 0-1-.45-1-1s.45-1 1-1h2v-2c0-.55.45-1 1-1s1 .45 1 1v2h2c.55 0 1 .45 1 1s-.45 1-1 1z" })));
};

var css_248z$2 = ".TextInput-module_root__1LQ5A {\n  display: flex;\n  background-color: rgba(33, 33, 33, 0.08);\n  flex-direction: row;\n  border-radius: 4px 4px 0 0;\n  border-bottom: 2px solid transparent;\n  padding: 0 16px;\n}\n.TextInput-module_root__1LQ5A:focus-within {\n  border-bottom-color: #6bc8bb;\n}\n\n.TextInput-module_label__zSFLb {\n  position: relative;\n  flex: 1;\n}\n\n.TextInput-module_labelText__9KwZ7 {\n  color: rgba(0, 0, 0, 0.6);\n  cursor: text;\n  font-size: 16px;\n  line-height: 24px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  margin: 0;\n  transform: translate(0, 18px) scale(1);\n  transform-origin: top left;\n  transition: 200ms ease transform;\n  will-change: transform;\n}\n\n.TextInput-module_labelShrink__cfaSN {\n  font-size: 10px;\n}\n\n.TextInput-module_input__bLrqx {\n  padding: 24px 0px 6px;\n  border-radius: 4px 4px 0 0;\n  font-size: 16px;\n  line-height: 24px;\n  width: 100%;\n  box-sizing: border-box;\n  border: none;\n  background-color: transparent;\n}\n.TextInput-module_input__bLrqx:not(:placeholder-shown) ~ .TextInput-module_labelText__9KwZ7, .TextInput-module_input__bLrqx:focus ~ .TextInput-module_labelText__9KwZ7 {\n  transform: translate(0, 8px) scale(0.75);\n}\n.TextInput-module_input__bLrqx:focus {\n  outline: none;\n}\n.TextInput-module_input__bLrqx:focus ~ .TextInput-module_labelText__9KwZ7 {\n  color: #6bc8bb;\n}\n\n.TextInput-module_iconWrapper__AUl61 {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-top: 4px;\n}\n.TextInput-module_iconWrapper__AUl61 > svg {\n  color: rgba(0, 0, 0, 0.54);\n}\n\n.TextInput-module_startIconWrapper__sHd5R {\n  margin-right: 12px;\n}\n.TextInput-module_startIconWrapper__sHd5R svg {\n  font-size: 24px;\n}\n\n.TextInput-module_endIconWrapper__G2Sxe svg {\n  font-size: 24px;\n}";
var classes$2 = {"root":"TextInput-module_root__1LQ5A","label":"TextInput-module_label__zSFLb","labelText":"TextInput-module_labelText__9KwZ7","labelShrink":"TextInput-module_labelShrink__cfaSN","input":"TextInput-module_input__bLrqx","iconWrapper":"TextInput-module_iconWrapper__AUl61","startIconWrapper":"TextInput-module_startIconWrapper__sHd5R","endIconWrapper":"TextInput-module_endIconWrapper__G2Sxe"};
styleInject(css_248z$2);

var TextInput = function (_a) {
    var label = _a.label, placeholder = _a.placeholder, className = _a.className, startIcon = _a.startIcon, endIcon = _a.endIcon, props = __rest(_a, ["label", "placeholder", "className", "startIcon", "endIcon"]);
    return (React__default["default"].createElement("div", { className: clsx(classes$2.root, className) },
        React__default["default"].createElement("div", { className: clsx(classes$2.startIconWrapper, classes$2.iconWrapper) }, startIcon),
        React__default["default"].createElement("label", { className: classes$2.label },
            React__default["default"].createElement("input", __assign({ className: classes$2.input, placeholder: placeholder || ' ' }, props)),
            React__default["default"].createElement("span", { className: classes$2.labelText }, label)),
        React__default["default"].createElement("div", { className: clsx(classes$2.endIconWrapper, classes$2.iconWrapper) }, endIcon)));
};

var css_248z$1 = ".LoginPage-module_root__wvozE {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  padding: 16px;\n}\n@media (min-width: 850px) {\n  .LoginPage-module_root__wvozE {\n    flex-direction: row;\n    padding: 0;\n  }\n}\n.LoginPage-module_root__wvozE > * {\n  width: 100%;\n}\n@media (min-width: 850px) {\n  .LoginPage-module_root__wvozE > * {\n    max-width: 50vw;\n  }\n}\n.LoginPage-module_root__wvozE * {\n  font-family: \"Roboto\", sans-serif;\n}\n\n.LoginPage-module_logoWrapper__Ok8EE {\n  display: none;\n}\n@media (min-width: 850px) {\n  .LoginPage-module_logoWrapper__Ok8EE {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n.LoginPage-module_logoWrapper__Ok8EE svg {\n  width: 190px;\n  margin-top: 30px;\n}\n@media (min-width: 850px) {\n  .LoginPage-module_logoWrapper__Ok8EE svg {\n    width: 282px;\n    margin-top: 0;\n  }\n}\n@media (min-width: 850px) {\n  .LoginPage-module_logoWrapper__Ok8EE {\n    background-color: #6bc8bb;\n    color: #fff;\n  }\n}\n\n.LoginPage-module_formWrapper__QqmcW {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 66px;\n  padding-bottom: 20px;\n}\n@media (min-width: 850px) {\n  .LoginPage-module_formWrapper__QqmcW {\n    margin-top: 0px;\n    padding-bottom: 0;\n  }\n}\n\n.LoginPage-module_formContent__0BJ4m {\n  max-width: 328px;\n  width: 100%;\n}\n.LoginPage-module_formContent__0BJ4m > * {\n  width: 100%;\n}\n\n.LoginPage-module_paragraph__Ad95R {\n  font-size: 16px;\n  color: #372d41;\n  margin: 0;\n}\n\n.LoginPage-module_helperText__eyo6M {\n  font-size: 14px;\n  color: rgba(0, 0, 0, 0.6);\n  margin-top: 8px;\n}\n\n.LoginPage-module_title__qyWm8 {\n  font-size: 30px;\n  line-height: 35px;\n  color: #372d41;\n  margin: 0;\n  margin-top: 2px;\n  margin-bottom: 32px;\n}\n\n.LoginPage-module_divider__rgg8s {\n  margin-top: 48px;\n  margin-bottom: 48px;\n  text-align: center;\n}\n\n.LoginPage-module_alignRight__VmDVZ {\n  text-align: right;\n}\n\n.LoginPage-module_accordion__xQ6BP {\n  margin-top: 48px;\n}\n\n.LoginPage-module_form__6ncKH {\n  margin-top: 48px;\n}\n\n.LoginPage-module_input__khmD8 {\n  margin-bottom: 24px;\n}\n\n.LoginPage-module_showPasswordBtn__3fza0 {\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n}\n.LoginPage-module_showPasswordBtn__3fza0:active, .LoginPage-module_showPasswordBtn__3fza0:focus {\n  outline: none;\n}\n.LoginPage-module_showPasswordBtn__3fza0 svg {\n  color: rgba(0, 0, 0, 0.54);\n}\n\n.LoginPage-module_languagePicker__i-Jk0 {\n  position: absolute;\n  top: 4px;\n  right: 0;\n  display: none;\n}\n@media (min-width: 850px) {\n  .LoginPage-module_languagePicker__i-Jk0 {\n    top: 24px;\n    right: 24px;\n    display: block;\n  }\n}\n\n.LoginPage-module_header__Hj6Qc {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 328px;\n  margin: 0 auto;\n}\n.LoginPage-module_header__Hj6Qc .LoginPage-module_languagePicker__i-Jk0 {\n  position: relative;\n  margin-right: -18px;\n  display: block;\n}\n@media (min-width: 850px) {\n  .LoginPage-module_header__Hj6Qc {\n    display: none;\n  }\n}";
var classes$1 = {"root":"LoginPage-module_root__wvozE","logoWrapper":"LoginPage-module_logoWrapper__Ok8EE","formWrapper":"LoginPage-module_formWrapper__QqmcW","formContent":"LoginPage-module_formContent__0BJ4m","paragraph":"LoginPage-module_paragraph__Ad95R","helperText":"LoginPage-module_helperText__eyo6M","title":"LoginPage-module_title__qyWm8","divider":"LoginPage-module_divider__rgg8s","alignRight":"LoginPage-module_alignRight__VmDVZ","accordion":"LoginPage-module_accordion__xQ6BP","form":"LoginPage-module_form__6ncKH","input":"LoginPage-module_input__khmD8","showPasswordBtn":"LoginPage-module_showPasswordBtn__3fza0","languagePicker":"LoginPage-module_languagePicker__i-Jk0","header":"LoginPage-module_header__Hj6Qc"};
styleInject(css_248z$1);

var LoginPage = function () {
    var t = useTranslation().t;
    var _a = React.useState(false), showPassword = _a[0], setShowPassword = _a[1];
    var _b = useLogin(), handleLoginWithGoogle = _b.handleLoginWithGoogle, loginError = _b.loginError, logingInWithGoogle = _b.logingInWithGoogle, logingInWithEmailAndPassword = _b.logingInWithEmailAndPassword, handleLoginWithEmailAndPassword = _b.handleLoginWithEmailAndPassword, handleEmailChange = _b.handleEmailChange, handlePasswordChange = _b.handlePasswordChange, email = _b.email, password = _b.password;
    var isInvalid = email === '' || password === '';
    var handleToggleShowPassword = function () {
        setShowPassword(function (value) { return !value; });
    };
    var handleSubmit = function (event) {
        event.preventDefault();
        handleLoginWithEmailAndPassword({ email: email, password: password });
    };
    return (React__default["default"].createElement("div", { className: classes$1.root },
        React__default["default"].createElement(LanguagePicker, { className: classes$1.languagePicker }),
        React__default["default"].createElement("header", { className: classes$1.header },
            React__default["default"].createElement(MasterLogo, null),
            React__default["default"].createElement(LanguagePicker, { className: classes$1.languagePicker })),
        React__default["default"].createElement("section", { className: classes$1.logoWrapper },
            React__default["default"].createElement(LogoWhite, null)),
        React__default["default"].createElement("section", { className: classes$1.formWrapper },
            React__default["default"].createElement("div", { className: classes$1.formContent },
                React__default["default"].createElement("p", { className: classes$1.paragraph }, t('welcome')),
                React__default["default"].createElement("h1", { className: classes$1.title }, t('sign_in')),
                React__default["default"].createElement(Button, { onClick: handleLoginWithGoogle, color: "secondary", startIcon: React__default["default"].createElement(GoogleLogo, null), disabled: logingInWithGoogle }, t('sign_in_with_google')),
                loginError && React__default["default"].createElement(HelperText, { color: "error" }, t(loginError)),
                React__default["default"].createElement(Accordion, { className: classes$1.accordion, title: t('or') },
                    React__default["default"].createElement("form", { onSubmit: handleSubmit, className: classes$1.form },
                        React__default["default"].createElement(TextInput, { label: t('email'), name: "email", type: "email", className: classes$1.input, onChange: handleEmailChange, startIcon: React__default["default"].createElement(EmailIcon, null), required: true, autoFocus: true }),
                        React__default["default"].createElement(TextInput, { type: showPassword ? 'text' : 'password', label: t('password'), name: "password", className: classes$1.input, required: true, startIcon: React__default["default"].createElement(PasswordIcon, null), endIcon: React__default["default"].createElement("button", { className: classes$1.showPasswordBtn, type: "button", onClick: handleToggleShowPassword }, showPassword ? React__default["default"].createElement(HidePasswordIcon, null) : React__default["default"].createElement(EyeIcon, null)), onChange: handlePasswordChange }),
                        React__default["default"].createElement(Button, { fullWidth: true, color: "primary", disabled: logingInWithEmailAndPassword || logingInWithGoogle || isInvalid }, "Login now")))))));
};
var LoginPageContainer = function () {
    return (React__default["default"].createElement(I18nextProvider, { i18n: i18nInstance },
        React__default["default"].createElement(LoginPage, null)));
};

var css_248z = ".Unauthorized-module_root__dz9Z1 {\n  color: rgb(97, 26, 21);\n  background-color: rgb(253, 236, 234);\n  padding: 16px;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.Unauthorized-module_title__DNdN1 {\n  margin-top: -2px;\n  font-weight: 500;\n  margin-bottom: 0.35em;\n  font-size: 18px;\n}";
var classes = {"root":"Unauthorized-module_root__dz9Z1","title":"Unauthorized-module_title__DNdN1"};
styleInject(css_248z);

var Unauthorized = function () { return (React__default["default"].createElement("div", { className: classes.root },
    React__default["default"].createElement("p", { className: classes.title }, "Access Denied"),
    React__default["default"].createElement("p", null, "You do not have sufficient permission to view this page. Please contact your administrator for more details."))); };

var ProtectedRoute = function (_a) {
    var view = _a.view, children = _a.children;
    var authentication = useCredentials().authentication;
    var application = useSecurityConfig().application;
    return authentication && application && view && !hasAccessToTheView(application, view, authentication) ? (React__default["default"].createElement(Unauthorized, null)) : (React__default["default"].createElement(AuthenticationHandler, null, children));
};

var init = '';
var TrustedDeviceContext = React.createContext(init);
var TrustedDeviceContextChange = React.createContext(function () { });
var TrustedDeviceProvider = function (_a) {
    var children = _a.children;
    var _b = useStickyState(init, trustedDeviceStorageKey), trustedDevice = _b[0], setTrustedDevice = _b[1];
    return (React__default["default"].createElement(TrustedDeviceContext.Provider, { value: trustedDevice },
        React__default["default"].createElement(TrustedDeviceContextChange.Provider, { value: setTrustedDevice }, children)));
};
var useSetTrustedDevice = function () {
    var context = React.useContext(TrustedDeviceContextChange);
    if (!context) {
        throw new Error('useSetTrustedDevice must be used within the TrustedDeviceProvider.');
    }
    return context;
};

var SecurityProvider = function (_a) {
    var config = _a.config, router = _a.router, children = _a.children;
    React.useEffect(function () {
        i18nInstance.changeLanguage(config.defaultLanguage || 'de');
    }, [config.defaultLanguage]);
    return (React__default["default"].createElement(RouterProvider, { value: router },
        React__default["default"].createElement(SecurityConfigProvider, { value: config },
            React__default["default"].createElement(CredentialsProvider, null,
                React__default["default"].createElement(TrustedDeviceProvider, null, children)))));
};

var useCheckResetToken = function (_a) {
    var kind = _a.kind, _b = _a.onSuccess, onSuccess = _b === void 0 ? function () { return false; } : _b, _c = _a.onError, onError = _c === void 0 ? function () { return false; } : _c;
    var _d = React.useState(false), checkLoading = _d[0], setCheckLoading = _d[1];
    var _e = React.useState(null), checkError = _e[0], setCheckError = _e[1];
    var _f = React.useState(false), checkSuccess = _f[0], setCheckSuccess = _f[1];
    var action = (function () {
        if (kind === exports.ResetAuthPartKind.PASSWORD)
            return getCheckResetPasswordToken;
        return getCheckResetPhoneNumberToken;
    })();
    var checkToken = React.useCallback(function (data) {
        setCheckLoading(true);
        setCheckError(null);
        action(data)
            .then(function (result) {
            onSuccess(result);
            setCheckSuccess(null);
        })
            .catch(function (error) {
            setCheckError(error);
            onError(error);
        })
            .finally(function () {
            setCheckLoading(false);
        });
    }, [setCheckLoading, setCheckError]);
    return {
        isLoading: checkLoading,
        isSuccess: checkSuccess,
        error: checkError,
        checkToken: checkToken,
    };
};

var useEnrollments = function (_a) {
    var onSuccess = _a.onSuccess;
    var _b = React.useState(false), isLoading = _b[0], setIsLoading = _b[1];
    var _c = React.useState(null), error = _c[0], setError = _c[1];
    var submit = React.useCallback(function (fields) {
        setIsLoading(true);
        setError(null);
        return postEnrollments(fields)
            .catch(setError)
            .then(function () {
            onSuccess && onSuccess();
        })
            .finally(function () {
            setIsLoading(false);
        });
    }, [setIsLoading, setError, onSuccess]);
    return { submit: submit, isLoading: isLoading, error: error };
};

var initialHistory = {
    push: function () { },
    redirect: function () { },
};
var HistoryContext = React.createContext(initialHistory);
var useHistory = function () {
    var context = React.useContext(HistoryContext);
    if (context === undefined)
        throw new Error('`useHistory` must be used within `HistoryProvider`');
    return context;
};

exports.PatientLogoutKind = void 0;
(function (PatientLogoutKind) {
    PatientLogoutKind["MANUAL"] = "PATIENT_MANUAL_LOGOUT";
    PatientLogoutKind["AUTO"] = "PATIENT_AUTO_LOGOUT";
    PatientLogoutKind["EXPIRED"] = "PATIENT_TOKEN_EXPIRED";
    PatientLogoutKind["DELETION"] = "PATIENT_USER_ACCOUNT_DELETION";
})(exports.PatientLogoutKind || (exports.PatientLogoutKind = {}));
exports.LogoutKind = void 0;
(function (LogoutKind) {
    LogoutKind["MANUAL"] = "MANUAL_LOGOUT";
    LogoutKind["AUTO"] = "AUTO_LOGOUT";
    LogoutKind["EXPIRED"] = "TOKEN_EXPIRED";
    LogoutKind["DELETION"] = "USER_ACCOUNT_DELETION";
    LogoutKind["PHONE_NUMBER_CHANGED"] = "PHONE_NUMBER_CHANGED";
    LogoutKind["PHONE_NUMBER_CHANGE_TOKEN_EXPIRED"] = "PHONE_NUMBER_CHANGE_TOKEN_EXPIRED";
})(exports.LogoutKind || (exports.LogoutKind = {}));
/* A React hook that provides a function to logout from the application.
 */
var useLogout = function (params) {
    var _a;
    var kind = (_a = (params && params.kind)) !== null && _a !== void 0 ? _a : exports.LogoutKind.MANUAL; // By default "MANUAL" kind is set
    var securityConfig = useSecurityConfig();
    var setCredentials = useSetCredentials();
    var token = useCredentials().token;
    var history = useHistory();
    return function () {
        return logout({ token: token, kind: kind }).finally(function () {
            setCredentials(null, 'local');
            setCredentials(null, 'session');
            history.push(securityConfig.loginPath);
        });
    };
};

var useMissingConsents = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.onError, onError = _c === void 0 ? function () { return false; } : _c, _d = _b.onTokenExpired, onTokenExpired = _d === void 0 ? function () { return false; } : _d;
    var _e = React.useState(false), loading = _e[0], setLoading = _e[1];
    var _f = React.useState(null), error = _f[0], setError = _f[1];
    var token = useCredentials().token;
    var securityConfig = useSecurityConfig();
    var setCredentials = useSetCredentials();
    var router = useRouter();
    React.useEffect(function () {
        if (token) {
            var expiredTimer_1 = setTimeout(function () { return onTokenExpired(); }, getTokenRemainingTimeToExpireInMs(token));
            return function () {
                clearTimeout(expiredTimer_1);
            };
        }
    }, [token]);
    var handleMissingConsents = React.useCallback(function (data) {
        setLoading(true);
        setError(null);
        postMissingConsents(data)
            .then(function (_a) {
            var user = _a.user, missingConsents = _a.missingConsents, token = _a.token, refreshToken = _a.refreshToken;
            if (!token && !refreshToken) {
                setCredentials(null, 'local');
                return router.push(securityConfig.loginPath);
            }
            setCredentials({ authentication: user, missingConsents: missingConsents, refreshToken: refreshToken, token: token }, 'local');
            router.push(securityConfig.successPath);
        })
            .catch(function (error) {
            setError(error);
            onError(error);
        })
            .finally(function () {
            setLoading(false);
        });
    }, [setLoading, setError]);
    return {
        handleMissingConsents: handleMissingConsents,
        isLoading: loading,
        error: error,
    };
};

var isShortRegistration = function (data) {
    return 'token' in data;
};
var useRegistration = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.onSuccess, onSuccess = _c === void 0 ? function () { return false; } : _c, _d = _b.onError, onError = _d === void 0 ? function () { return false; } : _d;
    var _e = React.useState(false), registrationLoading = _e[0], setRegistrationLoading = _e[1];
    var _f = React.useState(null), registrationError = _f[0], setRegistrationError = _f[1];
    var setCredentials = useSetCredentials();
    var registerUser = React.useCallback(function (data) {
        setRegistrationLoading(true);
        setRegistrationError(null);
        var promise = (function () {
            if (isShortRegistration(data))
                return postShortRegisterUser(data);
            return postRegisterUser(data);
        })();
        promise
            .then(function (result) {
            onSuccess(result);
            setCredentials({ token: result.token }, 'local');
        })
            .catch(function (error) {
            setRegistrationError(error);
            onError(error);
        })
            .finally(function () {
            setRegistrationLoading(false);
        });
    }, [setRegistrationLoading, setRegistrationError]);
    return {
        isLoading: registrationLoading,
        error: registrationError,
        registerUser: registerUser,
    };
};

var useResendVerificationCode = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.onSuccess, onSuccess = _c === void 0 ? function () { return false; } : _c, _d = _b.onError, onError = _d === void 0 ? function () { return false; } : _d, _e = _b.onTokenExpired, onTokenExpired = _e === void 0 ? function () { return false; } : _e;
    var _f = React.useState(false), loading = _f[0], setLoading = _f[1];
    var _g = React.useState(null), error = _g[0], setError = _g[1];
    var _h = React.useState(false), succeeded = _h[0], setSucceeded = _h[1];
    var token = useCredentials().token;
    var setCredentials = useSetCredentials();
    React.useEffect(function () {
        if (token) {
            var expiredTimer_1 = setTimeout(function () { return onTokenExpired(); }, getTokenRemainingTimeToExpireInMs(token));
            return function () {
                clearTimeout(expiredTimer_1);
            };
        }
    }, [token]);
    var resend = React.useCallback(function () {
        setLoading(true);
        setError(null);
        setSucceeded(null);
        postResendVerificationCode()
            .then(function (result) {
            setCredentials({ token: result }, 'local');
            onSuccess(result);
            setSucceeded(true);
        })
            .catch(function (error) {
            setError(error);
            onError(error);
        })
            .finally(function () {
            setLoading(false);
        });
    }, [setLoading, setError]);
    return {
        isLoading: loading,
        isSuccess: succeeded,
        error: error,
        resend: token ? resend : undefined,
    };
};

var useResendVerificationEmail = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.onSuccess, onSuccess = _c === void 0 ? function () { return false; } : _c, _d = _b.onError, onError = _d === void 0 ? function () { return false; } : _d;
    var _e = React.useState(false), loading = _e[0], setLoading = _e[1];
    var _f = React.useState(null), error = _f[0], setError = _f[1];
    var _g = React.useState(false), succeeded = _g[0], setSucceeded = _g[1];
    var token = useCredentials().token;
    var resend = React.useCallback(function () {
        setLoading(true);
        setError(null);
        setSucceeded(null);
        postResendVerificationEmail()
            .then(function (result) {
            onSuccess(result);
            setSucceeded(true);
        })
            .catch(function (error) {
            setError(error);
            onError(error);
        })
            .finally(function () {
            setLoading(false);
        });
    }, [setLoading, setError]);
    return {
        isLoading: loading,
        isSuccess: succeeded,
        error: error,
        resend: token ? resend : undefined,
    };
};

var useResetAuthPart = function (_a) {
    var kind = _a.kind, _b = _a.onSuccess, onSuccess = _b === void 0 ? function () { return false; } : _b, _c = _a.onError, onError = _c === void 0 ? function () { return false; } : _c;
    var _d = React.useState(false), isLoading = _d[0], setIsLoading = _d[1];
    var _e = React.useState(null), error = _e[0], setError = _e[1];
    var _f = React.useState(false), isSuccess = _f[0], setIsSuccess = _f[1];
    var reset = React.useCallback(function (data) {
        setIsLoading(true);
        setError(null);
        setIsSuccess(null);
        var action = (function () {
            if (kind === exports.ResetAuthPartKind.PASSWORD)
                return postResetPasswordInitialization;
            return postResetPhoneNumberInitialization;
        })();
        action(data)
            .then(function (result) {
            onSuccess(result);
            setIsSuccess(true);
        })
            .catch(function (error) {
            setError(error);
            onError(error);
        })
            .finally(function () {
            setIsLoading(false);
        });
    }, [setIsLoading, setError]);
    return {
        isLoading: isLoading,
        isSuccess: isSuccess,
        error: error,
        reset: reset,
    };
};

var useResetPassword = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.onSuccess, onSuccess = _c === void 0 ? function () { return false; } : _c, _d = _b.onError, onError = _d === void 0 ? function () { return false; } : _d;
    var _e = React.useState(false), resetPasswordLoading = _e[0], setResetPasswordLoading = _e[1];
    var _f = React.useState(null), resetPasswordError = _f[0], setResetPasswordError = _f[1];
    var _g = React.useState(false), resetPasswordSuccess = _g[0], setResetPasswordSuccess = _g[1];
    var resetPassword = React.useCallback(function (data) {
        setResetPasswordLoading(true);
        setResetPasswordError(null);
        setResetPasswordSuccess(null);
        putResetPassword(data)
            .then(function (result) {
            onSuccess(result);
            setResetPasswordSuccess(true);
        })
            .catch(function (error) {
            setResetPasswordError(error);
            onError(error);
        })
            .finally(function () {
            setResetPasswordLoading(false);
        });
    }, [setResetPasswordLoading, setResetPasswordError]);
    return {
        isLoading: resetPasswordLoading,
        isSuccess: resetPasswordSuccess,
        error: resetPasswordError,
        resetPassword: resetPassword,
    };
};

var useResetPhoneNumber = function (_a) {
    var token = _a.token, _b = _a.onSuccess, onSuccess = _b === void 0 ? function () { return false; } : _b, _c = _a.onError, onError = _c === void 0 ? function () { return false; } : _c;
    var _d = React.useState(false), isLoading = _d[0], setIsLoading = _d[1];
    var _e = React.useState(null), error = _e[0], setError = _e[1];
    var _f = React.useState(false), isSuccess = _f[0], setIsSuccess = _f[1];
    var resetPhoneNumber = React.useCallback(function (data) {
        setIsLoading(true);
        setError(null);
        setIsSuccess(null);
        postResetPhoneNumber(__assign({ token: token }, data))
            .then(function (result) {
            onSuccess(result);
            setIsSuccess(true);
        })
            .catch(function (error) {
            setError(error);
            onError(error);
        })
            .finally(function () {
            setIsLoading(false);
        });
    }, [setIsLoading, setError, token]);
    return {
        isLoading: isLoading,
        isSuccess: isSuccess,
        error: error,
        resetPhoneNumber: resetPhoneNumber,
    };
};

var isLanguageSupported = function (language) {
    return !!exports.Language[language.toUpperCase()];
};
var useSetPreferredLang = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.onSuccess, onSuccess = _c === void 0 ? function () { return false; } : _c, _d = _b.onError, onError = _d === void 0 ? function () { return false; } : _d;
    var setCredentials = useSetCredentials();
    var _e = useCredentials(), authentication = _e.authentication, token = _e.token;
    var _f = React.useState(false), loading = _f[0], setLoading = _f[1];
    var _g = React.useState(null), error = _g[0], setError = _g[1];
    var _h = React.useState(false), success = _h[0], setSuccess = _h[1];
    var setPreferredLang = function (languageCode) {
        if (!isLanguageSupported(languageCode))
            return console.warn("The language '" + languageCode + "' is not supported");
        if (authentication && authentication.personReferenceId && !isPartial(token)) {
            setLoading(true);
            setError(null);
            setSuccess(null);
            patchSetPreferredLanguage({
                languageCode: languageCode,
                referenceId: authentication.referenceId,
            })
                .then(function (result) {
                setCredentials({ authentication: result }, 'local');
                onSuccess(result);
                setSuccess(true);
            })
                .catch(function (error) {
                setError(error);
                onError(error);
            })
                .finally(function () {
                setLoading(false);
            });
        }
    };
    return {
        isLoading: loading,
        isSuccess: success,
        error: error,
        setPreferredLang: setPreferredLang,
    };
};

var useTwoFactorAuth = function (_a) {
    var _b = _a === void 0 ? {} : _a, onSuccess = _b.onSuccess, _c = _b.onError, onError = _c === void 0 ? function () { return false; } : _c;
    var securityConfig = useSecurityConfig();
    var setSecurity = useSetCredentials();
    var setTrustedDevice = useSetTrustedDevice();
    var router = useRouter();
    var _d = React.useState(false), isLoading = _d[0], setIsLoading = _d[1];
    var _e = React.useState(null), error = _e[0], setError = _e[1];
    var handleTowFactorVerification = React.useCallback(function (body) {
        setIsLoading(true);
        twoFactorVerification(body)
            .then(function (_a) {
            var user = _a.user, token = _a.token, refreshToken = _a.refreshToken, missingConsents = _a.missingConsents, trustedDeviceId = _a.trustedDeviceId;
            if (trustedDeviceId) {
                setTrustedDevice(trustedDeviceId, 'local');
            }
            setSecurity({ authentication: user, token: token, refreshToken: refreshToken, missingConsents: missingConsents }, 'local');
            if (onSuccess) {
                return onSuccess();
            }
            router.push(securityConfig.successPath);
        })
            .catch(function (error) {
            setError(error);
            onError(error);
        })
            .finally(function () {
            setIsLoading(false);
        });
    }, [setSecurity, setError, setIsLoading]);
    return {
        error: error,
        isLoading: isLoading,
        handleTowFactorVerification: handleTowFactorVerification,
    };
};

var useAutoLogin = function (timeout) {
    if (timeout === void 0) { timeout = 0; }
    var router = useRouter();
    var securityConfig = useSecurityConfig();
    var setCredentials = useSetCredentials();
    return React.useCallback(function (_a) {
        var user = _a.user, token = _a.token, refreshToken = _a.refreshToken;
        if (user && token && refreshToken) {
            setCredentials({ token: token, refreshToken: refreshToken, authentication: user }, 'local');
            return setTimeout(function () {
                router.push(securityConfig.successPath);
            }, timeout);
        }
    }, []);
};

var useVerifyEmail = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.onSuccess, onSuccess = _c === void 0 ? function () { return false; } : _c, _d = _b.onError, onError = _d === void 0 ? function () { return false; } : _d;
    var _e = React.useState(false), verifyEmailLoading = _e[0], setVerifyEmailLoading = _e[1];
    var _f = React.useState(null), verifyEmailError = _f[0], setVerifyEmailError = _f[1];
    var _g = React.useState(false), verifyEmailSuccess = _g[0], setVerifyEmailSuccess = _g[1];
    var autoLogin = useAutoLogin(2000);
    var mobileToken = useCredentials().token;
    var verifyEmail = React.useCallback(function (token) {
        setVerifyEmailLoading(true);
        setVerifyEmailError(null);
        postVerifyEmail(token, mobileToken || undefined)
            .then(function (res) {
            onSuccess(res);
            setVerifyEmailSuccess(true);
            autoLogin(res);
        })
            .catch(function (error) {
            setVerifyEmailError(error);
            onError(error);
        })
            .finally(function () {
            setVerifyEmailLoading(false);
        });
    }, [setVerifyEmailLoading, setVerifyEmailError]);
    return {
        isLoading: verifyEmailLoading,
        isSuccess: verifyEmailSuccess,
        error: verifyEmailError,
        verifyEmail: verifyEmail,
    };
};

var useVerifyPhone = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.onSuccess, onSuccess = _c === void 0 ? function () { return false; } : _c, _d = _b.onError, onError = _d === void 0 ? function () { return false; } : _d;
    var securityConfig = useSecurityConfig();
    var setCredentials = useSetCredentials();
    var router = useRouter();
    var autoLogin = useAutoLogin();
    var setTrustedDevice = useSetTrustedDevice();
    var _e = React.useState(false), verifyPhoneLoading = _e[0], setVerifyPhoneLoading = _e[1];
    var _f = React.useState(null), verifyPhoneError = _f[0], setVerifyPhoneError = _f[1];
    var verifyPhone = React.useCallback(function (data) {
        setVerifyPhoneLoading(true);
        setVerifyPhoneError(null);
        postVerifyPhone(__assign({}, data))
            .then(function (res) {
            if (res.trustedDeviceId) {
                setTrustedDevice(res.trustedDeviceId, 'local');
            }
            onSuccess(res);
            autoLogin(res);
            setCredentials({ token: res.token }, 'local');
            router.push(securityConfig.emailVerificationPath);
        })
            .catch(function (error) {
            setVerifyPhoneError(error);
            onError(error);
        })
            .finally(function () {
            setVerifyPhoneLoading(false);
        });
    }, [setVerifyPhoneLoading, setVerifyPhoneError]);
    return {
        isLoading: verifyPhoneLoading,
        error: verifyPhoneError,
        verifyPhone: verifyPhone,
    };
};

var useVerifyPhoneReset = function (_a) {
    var token = _a.token, onError = _a.onError, onSuccess = _a.onSuccess;
    var autoLogin = useAutoLogin();
    var _b = React.useState(false), isLoading = _b[0], isSetLoading = _b[1];
    var _c = React.useState(null), error = _c[0], setError = _c[1];
    var verifyPhoneReset = React.useCallback(function (data) {
        isSetLoading(true);
        setError(null);
        postVerifyPhoneReset(__assign(__assign({}, data), { token: token }))
            .then(function (res) {
            autoLogin(res);
            onSuccess(res);
        })
            .catch(function (error) {
            setError(error);
            onError(error);
        })
            .finally(function () {
            isSetLoading(false);
        });
    }, [isSetLoading, setError]);
    return {
        isLoading: isLoading,
        error: error,
        verifyPhoneReset: verifyPhoneReset,
    };
};

exports.AuthenticationHandler = AuthenticationHandler;
exports.LoginPage = LoginPageContainer;
exports.ProtectedRoute = ProtectedRoute;
exports.SecurityProvider = SecurityProvider;
exports.addAuthInterceptors = addAuthInterceptors;
exports.decodeToken = decodeToken;
exports.hasAccessToTheApplication = hasAccessToTheApplication;
exports.hasAccessToTheView = hasAccessToTheView;
exports.useCheckResetToken = useCheckResetToken;
exports.useCredentials = useCredentials;
exports.useEnrollments = useEnrollments;
exports.useLogin = useLogin;
exports.useLogout = useLogout;
exports.useMissingConsents = useMissingConsents;
exports.useRegistration = useRegistration;
exports.useResendVerificationCode = useResendVerificationCode;
exports.useResendVerificationEmail = useResendVerificationEmail;
exports.useResetAuthPart = useResetAuthPart;
exports.useResetPassword = useResetPassword;
exports.useResetPhoneNumber = useResetPhoneNumber;
exports.useSetCredentials = useSetCredentials;
exports.useSetPreferredLang = useSetPreferredLang;
exports.useTwoFactorAuth = useTwoFactorAuth;
exports.useVerifyEmail = useVerifyEmail;
exports.useVerifyPhone = useVerifyPhone;
exports.useVerifyPhoneReset = useVerifyPhoneReset;
//# sourceMappingURL=index.js.map
